export const dynamicOptions = [
  {
    idCollection: ['48c1bcad-3d2b-4cc1-a44d-dc422eb47af0'],
    data: [
      { label: 'Micro Empresa', value: 'ME' },
      { label: 'Pequena Empresa', value: 'EPP' },
      { label: 'Média/Grande Empresa', value: 'DEMAIS' },
    ],
  },
  {
    idCollection: [
      'cbe4d356-bd28-4d50-996c-8ff3c7bf271e',
      '018da355-4451-408f-a078-c4728b1a5d6d',
    ],
    data: [
      {
        value: '0111301',
        label: 'Cultivo de arroz',
      },
      {
        value: '0111302',
        label: 'Cultivo de milho',
      },
      {
        value: '0111303',
        label: 'Cultivo de trigo',
      },
      {
        value: '0111399',
        label: 'Cultivo de outros cereais não especificados anteriormente',
      },
      {
        value: '0112101',
        label: 'Cultivo de algodão herbáceo',
      },
      {
        value: '0112102',
        label: 'Cultivo de juta',
      },
      {
        value: '0112199',
        label:
          'Cultivo de outras fibras de lavoura temporária não especificadas anteriormente',
      },
      {
        value: '0113000',
        label: 'Cultivo de cana-de-açúcar',
      },
      {
        value: '0114800',
        label: 'Cultivo de fumo',
      },
      {
        value: '0115600',
        label: 'Cultivo de soja',
      },
      {
        value: '0116401',
        label: 'Cultivo de amendoim',
      },
      {
        value: '0116402',
        label: 'Cultivo de girassol',
      },
      {
        value: '0116403',
        label: 'Cultivo de mamona',
      },
      {
        value: '0116499',
        label:
          'Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente',
      },
      {
        value: '0119901',
        label: 'Cultivo de abacaxi',
      },
      {
        value: '0119902',
        label: 'Cultivo de alho',
      },
      {
        value: '0119903',
        label: 'Cultivo de batata-inglesa',
      },
      {
        value: '0119904',
        label: 'Cultivo de cebola',
      },
      {
        value: '0119905',
        label: 'Cultivo de feijão',
      },
      {
        value: '0119906',
        label: 'Cultivo de mandioca',
      },
      {
        value: '0119907',
        label: 'Cultivo de melão',
      },
      {
        value: '0119908',
        label: 'Cultivo de melancia',
      },
      {
        value: '0119909',
        label: 'Cultivo de tomate rasteiro',
      },
      {
        value: '0119999',
        label:
          'Cultivo de outras plantas de lavoura temporária não especificadas anteriormente',
      },
      {
        value: '0121101',
        label: 'Horticultura, exceto morango',
      },
      {
        value: '0121102',
        label: 'Cultivo de morango',
      },
      {
        value: '0122900',
        label: 'Cultivo de flores e plantas ornamentais',
      },
      {
        value: '0131800',
        label: 'Cultivo de laranja',
      },
      {
        value: '0132600',
        label: 'Cultivo de uva',
      },
      {
        value: '0133401',
        label: 'Cultivo de açaí',
      },
      {
        value: '0133402',
        label: 'Cultivo de banana',
      },
      {
        value: '0133403',
        label: 'Cultivo de caju',
      },
      {
        value: '0133404',
        label: 'Cultivo de cítricos, exceto laranja',
      },
      {
        value: '0133405',
        label: 'Cultivo de coco-da-baía',
      },
      {
        value: '0133406',
        label: 'Cultivo de guaraná',
      },
      {
        value: '0133407',
        label: 'Cultivo de maçã',
      },
      {
        value: '0133408',
        label: 'Cultivo de mamão',
      },
      {
        value: '0133409',
        label: 'Cultivo de maracujá',
      },
      {
        value: '0133410',
        label: 'Cultivo de manga',
      },
      {
        value: '0133411',
        label: 'Cultivo de pêssego',
      },
      {
        value: '0133499',
        label:
          'Cultivo de frutas de lavoura permanente não especificadas anteriormente',
      },
      {
        value: '0134200',
        label: 'Cultivo de café',
      },
      {
        value: '0135100',
        label: 'Cultivo de cacau',
      },
      {
        value: '0139301',
        label: 'Cultivo de chá-da-índia',
      },
      {
        value: '0139302',
        label: 'Cultivo de erva-mate',
      },
      {
        value: '0139303',
        label: 'Cultivo de pimenta-do-reino',
      },
      {
        value: '0139304',
        label: 'Cultivo de plantas para condimento, exceto pimenta-do-reino',
      },
      {
        value: '0139305',
        label: 'Cultivo de dendê',
      },
      {
        value: '0139306',
        label: 'Cultivo de seringueira',
      },
      {
        value: '0139399',
        label:
          'Cultivo de outras plantas de lavoura permanente não especificadas anteriormente',
      },
      {
        value: '0141501',
        label:
          'Produção de sementes certificadas, exceto de forrageiras para pasto',
      },
      {
        value: '0141502',
        label:
          'Produção de sementes certificadas de forrageiras para formação de pasto',
      },
      {
        value: '0142300',
        label:
          'Produção de mudas e outras formas de propagação vegetal, certificadas',
      },
      {
        value: '0151201',
        label: 'Criação de bovinos para corte',
      },
      {
        value: '0151202',
        label: 'Criação de bovinos para leite',
      },
      {
        value: '0151203',
        label: 'Criação de bovinos, exceto para corte e leite',
      },
      {
        value: '0152101',
        label: 'Criação de bufalinos',
      },
      {
        value: '0152102',
        label: 'Criação de eqüinos',
      },
      {
        value: '0152103',
        label: 'Criação de asininos e muares',
      },
      {
        value: '0153901',
        label: 'Criação de caprinos',
      },
      {
        value: '0153902',
        label: 'Criação de ovinos, inclusive para produção de lã',
      },
      {
        value: '0154700',
        label: 'Criação de suínos',
      },
      {
        value: '0155501',
        label: 'Criação de frangos para corte',
      },
      {
        value: '0155502',
        label: 'Produção de pintos de um dia',
      },
      {
        value: '0155503',
        label: 'Criação de outros galináceos, exceto para corte',
      },
      {
        value: '0155504',
        label: 'Criação de aves, exceto galináceos',
      },
      {
        value: '0155505',
        label: 'Produção de ovos',
      },
      {
        value: '0159801',
        label: 'Apicultura',
      },
      {
        value: '0159802',
        label: 'Criação de animais de estimação',
      },
      {
        value: '0159803',
        label: 'Criação de escargô',
      },
      {
        value: '0159804',
        label: 'Criação de bicho-da-seda',
      },
      {
        value: '0159899',
        label: 'Criação de outros animais não especificados anteriormente',
      },
      {
        value: '0161001',
        label: 'Serviço de pulverização e controle de pragas agrícolas',
      },
      {
        value: '0161002',
        label: 'Serviço de poda de árvores para lavouras',
      },
      {
        value: '0161003',
        label: 'Serviço de preparação de terreno, cultivo e colheita',
      },
      {
        value: '0161099',
        label:
          'Atividades de apoio à agricultura não especificadas anteriormente',
      },
      {
        value: '0162801',
        label: 'Serviço de inseminação artificial em animais',
      },
      {
        value: '0162802',
        label: 'Serviço de tosquiamento de ovinos',
      },
      {
        value: '0162803',
        label: 'Serviço de manejo de animais',
      },
      {
        value: '0162899',
        label: 'Atividades de apoio à pecuária não especificadas anteriormente',
      },
      {
        value: '0163600',
        label: 'Atividades de pós-colheita',
      },
      {
        value: '0170900',
        label: 'Caça e serviços relacionados',
      },
      {
        value: '0210101',
        label: 'Cultivo de eucalipto',
      },
      {
        value: '0210102',
        label: 'Cultivo de acácia-negra',
      },
      {
        value: '0210103',
        label: 'Cultivo de pinus',
      },
      {
        value: '0210104',
        label: 'Cultivo de teca',
      },
      {
        value: '0210105',
        label:
          'Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca',
      },
      {
        value: '0210106',
        label: 'Cultivo de mudas em viveiros florestais',
      },
      {
        value: '0210107',
        label: 'Extração de madeira em florestas plantadas',
      },
      {
        value: '0210108',
        label: 'Produção de carvão vegetal - florestas plantadas',
      },
      {
        value: '0210109',
        label: 'Produção de casca de acácia-negra - florestas plantadas',
      },
      {
        value: '0210199',
        label:
          'Produção de produtos não-madeireiros não especificados anteriormente em florestas plantadas',
      },
      {
        value: '0220901',
        label: 'Extração de madeira em florestas nativas',
      },
      {
        value: '0220902',
        label: 'Produção de carvão vegetal - florestas nativas',
      },
      {
        value: '0220903',
        label: 'Coleta de castanha-do-pará em florestas nativas',
      },
      {
        value: '0220904',
        label: 'Coleta de látex em florestas nativas',
      },
      {
        value: '0220905',
        label: 'Coleta de palmito em florestas nativas',
      },
      {
        value: '0220906',
        label: 'Conservação de florestas nativas',
      },
      {
        value: '0220999',
        label:
          'Coleta de produtos não-madeireiros não especificados anteriormente em florestas nativas',
      },
      {
        value: '0230600',
        label: 'Atividades de apoio à produção florestal',
      },
      {
        value: '0311601',
        label: 'Pesca de peixes em água salgada',
      },
      {
        value: '0311602',
        label: 'Pesca de crustáceos e moluscos em água salgada',
      },
      {
        value: '0311603',
        label: 'Coleta de outros produtos marinhos',
      },
      {
        value: '0311604',
        label: 'Atividades de apoio à pesca em água salgada',
      },
      {
        value: '0312401',
        label: 'Pesca de peixes em água doce',
      },
      {
        value: '0312402',
        label: 'Pesca de crustáceos e moluscos em água doce',
      },
      {
        value: '0312403',
        label: 'Coleta de outros produtos aquáticos de água doce',
      },
      {
        value: '0312404',
        label: 'Atividades de apoio à pesca em água doce',
      },
      {
        value: '0321301',
        label: 'Criação de peixes em água salgada e salobra',
      },
      {
        value: '0321302',
        label: 'Criação de camarões em água salgada e salobra',
      },
      {
        value: '0321303',
        label: 'Criação de ostras e mexilhões em água salgada e salobra',
      },
      {
        value: '0321304',
        label: 'Criação de peixes ornamentais em água salgada e salobra',
      },
      {
        value: '0321305',
        label: 'Atividades de apoio à aqüicultura em água salgada e salobra',
      },
      {
        value: '0321399',
        label:
          'Cultivos e semicultivos da aqüicultura em água salgada e salobra não especificados anteriormente',
      },
      {
        value: '0322101',
        label: 'Criação de peixes em água doce',
      },
      {
        value: '0322102',
        label: 'Criação de camarões em água doce',
      },
      {
        value: '0322103',
        label: 'Criação de ostras e mexilhões em água doce',
      },
      {
        value: '0322104',
        label: 'Criação de peixes ornamentais em água doce',
      },
      {
        value: '0322105',
        label: 'Ranicultura',
      },
      {
        value: '0322106',
        label: 'Criação de jacaré',
      },
      {
        value: '0322107',
        label: 'Atividades de apoio à aqüicultura em água doce',
      },
      {
        value: '0322199',
        label:
          'Cultivos e semicultivos da aqüicultura em água doce não especificados anteriormente',
      },
      {
        value: '0500301',
        label: 'Extração de carvão mineral',
      },
      {
        value: '0500302',
        label: 'Beneficiamento de carvão mineral',
      },
      {
        value: '0600001',
        label: 'Extração de petróleo e gás natural',
      },
      {
        value: '0600002',
        label: 'Extração e beneficiamento de xisto',
      },
      {
        value: '0600003',
        label: 'Extração e beneficiamento de areias betuminosas',
      },
      {
        value: '0710301',
        label: 'Extração de minério de ferro',
      },
      {
        value: '0710302',
        label:
          'Pelotização, sinterização e outros beneficiamentos de minério de ferro',
      },
      {
        value: '0721901',
        label: 'Extração de minério de alumínio',
      },
      {
        value: '0721902',
        label: 'Beneficiamento de minério de alumínio',
      },
      {
        value: '0722701',
        label: 'Extração de minério de estanho',
      },
      {
        value: '0722702',
        label: 'Beneficiamento de minério de estanho',
      },
      {
        value: '0723501',
        label: 'Extração de minério de manganês',
      },
      {
        value: '0723502',
        label: 'Beneficiamento de minério de manganês',
      },
      {
        value: '0724301',
        label: 'Extração de minério de metais preciosos',
      },
      {
        value: '0724302',
        label: 'Beneficiamento de minério de metais preciosos',
      },
      {
        value: '0725100',
        label: 'Extração de minerais radioativos',
      },
      {
        value: '0729401',
        label: 'Extração de minérios de nióbio e titânio',
      },
      {
        value: '0729402',
        label: 'Extração de minério de tungstênio',
      },
      {
        value: '0729403',
        label: 'Extração de minério de níquel',
      },
      {
        value: '0729404',
        label:
          'Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não especificados anteriormente',
      },
      {
        value: '0729405',
        label:
          'Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não-ferrosos não especificados anteriormente',
      },
      {
        value: '0810001',
        label: 'Extração de ardósia e beneficiamento associado',
      },
      {
        value: '0810002',
        label: 'Extração de granito e beneficiamento associado',
      },
      {
        value: '0810003',
        label: 'Extração de mármore e beneficiamento associado',
      },
      {
        value: '0810004',
        label: 'Extração de calcário e dolomita e beneficiamento associado',
      },
      {
        value: '0810005',
        label: 'Extração de gesso e caulim',
      },
      {
        value: '0810006',
        label:
          'Extração de areia, cascalho ou pedregulho e beneficiamento associado',
      },
      {
        value: '0810007',
        label: 'Extração de argila e beneficiamento associado',
      },
      {
        value: '0810008',
        label: 'Extração de saibro e beneficiamento associado',
      },
      {
        value: '0810009',
        label: 'Extração de basalto e beneficiamento associado',
      },
      {
        value: '0810010',
        label: 'Beneficiamento de gesso e caulim associado à extração',
      },
      {
        value: '0810099',
        label:
          'Extração e britamento de pedras e outros materiais para construção e beneficiamento associado',
      },
      {
        value: '0891600',
        label:
          'Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos',
      },
      {
        value: '0892401',
        label: 'Extração de sal marinho',
      },
      {
        value: '0892402',
        label: 'Extração de sal-gema',
      },
      {
        value: '0892403',
        label: 'Refino e outros tratamentos do sal',
      },
      {
        value: '0893200',
        label: 'Extração de gemas (pedras preciosas e semipreciosas)',
      },
      {
        value: '0899101',
        label: 'Extração de grafita',
      },
      {
        value: '0899102',
        label: 'Extração de quartzo',
      },
      {
        value: '0899103',
        label: 'Extração de amianto',
      },
      {
        value: '0899199',
        label:
          'Extração de outros minerais não-metálicos não especificados anteriormente',
      },
      {
        value: '0910600',
        label: 'Atividades de apoio à extração de petróleo e gás natural',
      },
      {
        value: '0990401',
        label: 'Atividades de apoio à extração de minério de ferro',
      },
      {
        value: '0990402',
        label:
          'Atividades de apoio à extração de minerais metálicos não-ferrosos',
      },
      {
        value: '0990403',
        label: 'Atividades de apoio à extração de minerais não-metálicos',
      },
      {
        value: '1011201',
        label: 'Frigorífico - abate de bovinos',
      },
      {
        value: '1011202',
        label: 'Frigorífico - abate de eqüinos',
      },
      {
        value: '1011203',
        label: 'Frigorífico - abate de ovinos e caprinos',
      },
      {
        value: '1011204',
        label: 'Frigorífico - abate de bufalinos',
      },
      {
        value: '1011205',
        label:
          'Matadouro - abate de reses sob contrato - exceto abate de suínos',
      },
      {
        value: '1012101',
        label: 'Abate de aves',
      },
      {
        value: '1012102',
        label: 'Abate de pequenos animais',
      },
      {
        value: '1012103',
        label: 'Frigorífico - abate de suínos',
      },
      {
        value: '1012104',
        label: 'Matadouro - abate de suínos sob contrato',
      },
      {
        value: '1013901',
        label: 'Fabricação de produtos de carne',
      },
      {
        value: '1013902',
        label: 'Preparação de subprodutos do abate',
      },
      {
        value: '1020101',
        label: 'Preservação de peixes, crustáceos e moluscos',
      },
      {
        value: '1020102',
        label: 'Fabricação de conservas de peixes, crustáceos e moluscos',
      },
      {
        value: '1031700',
        label: 'Fabricação de conservas de frutas',
      },
      {
        value: '1032501',
        label: 'Fabricação de conservas de palmito',
      },
      {
        value: '1032599',
        label:
          'Fabricação de conservas de legumes e outros vegetais, exceto palmito',
      },
      {
        value: '1033301',
        label:
          'Fabricação de sucos concentrados de frutas, hortaliças e legumes',
      },
      {
        value: '1033302',
        label:
          'Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados',
      },
      {
        value: '1041400',
        label: 'Fabricação de óleos vegetais em bruto, exceto óleo de milho',
      },
      {
        value: '1042200',
        label: 'Fabricação de óleos vegetais refinados, exceto óleo de milho',
      },
      {
        value: '1043100',
        label:
          'Fabricação de margarina e outras gorduras vegetais e de óleos não-comestíveis de animais',
      },
      {
        value: '1051100',
        label: 'Preparação do leite',
      },
      {
        value: '1052000',
        label: 'Fabricação de laticínios',
      },
      {
        value: '1053800',
        label: 'Fabricação de sorvetes e outros gelados comestíveis',
      },
      {
        value: '1061901',
        label: 'Beneficiamento de arroz',
      },
      {
        value: '1061902',
        label: 'Fabricação de produtos do arroz',
      },
      {
        value: '1062700',
        label: 'Moagem de trigo e fabricação de derivados',
      },
      {
        value: '1063500',
        label: 'Fabricação de farinha de mandioca e derivados',
      },
      {
        value: '1064300',
        label:
          'Fabricação de farinha de milho e derivados, exceto óleos de milho',
      },
      {
        value: '1065101',
        label: 'Fabricação de amidos e féculas de vegetais',
      },
      {
        value: '1065102',
        label: 'Fabricação de óleo de milho em bruto',
      },
      {
        value: '1065103',
        label: 'Fabricação de óleo de milho refinado',
      },
      {
        value: '1066000',
        label: 'Fabricação de alimentos para animais',
      },
      {
        value: '1069400',
        label:
          'Moagem e fabricação de produtos de origem vegetal não especificados anteriormente',
      },
      {
        value: '1071600',
        label: 'Fabricação de açúcar em bruto',
      },
      {
        value: '1072401',
        label: 'Fabricação de açúcar de cana refinado',
      },
      {
        value: '1072402',
        label: 'Fabricação de açúcar de cereais (dextrose) e de beterraba',
      },
      {
        value: '1081301',
        label: 'Beneficiamento de café',
      },
      {
        value: '1081302',
        label: 'Torrefação e moagem de café',
      },
      {
        value: '1082100',
        label: 'Fabricação de produtos à base de café',
      },
      {
        value: '1091100',
        label: 'Fabricação de produtos de panificação',
      },
      {
        value: '1091101',
        label: 'Fabricação de produtos de panificação industrial',
      },
      {
        value: '1091102',
        label:
          'Fabricação de produtos de padaria e confeitaria com predominância de produção própria',
      },
      {
        value: '1092900',
        label: 'Fabricação de biscoitos e bolachas',
      },
      {
        value: '1093701',
        label: 'Fabricação de produtos derivados do cacau e de chocolates',
      },
      {
        value: '1093702',
        label: 'Fabricação de frutas cristalizadas, balas e semelhantes',
      },
      {
        value: '1094500',
        label: 'Fabricação de massas alimentícias',
      },
      {
        value: '1095300',
        label: 'Fabricação de especiarias, molhos, temperos e condimentos',
      },
      {
        value: '1096100',
        label: 'Fabricação de alimentos e pratos prontos',
      },
      {
        value: '1099601',
        label: 'Fabricação de vinagres',
      },
      {
        value: '1099602',
        label: 'Fabricação de pós alimentícios',
      },
      {
        value: '1099603',
        label: 'Fabricação de fermentos e leveduras',
      },
      {
        value: '1099604',
        label: 'Fabricação de gelo comum',
      },
      {
        value: '1099605',
        label: 'Fabricação de produtos para infusão (chá, mate, etc.)',
      },
      {
        value: '1099606',
        label: 'Fabricação de adoçantes naturais e artificiais',
      },
      {
        value: '1099607',
        label: 'Fabricação de alimentos dietéticos e complementos alimentares',
      },
      {
        value: '1099699',
        label:
          'Fabricação de outros produtos alimentícios não especificados anteriormente',
      },
      {
        value: '1111901',
        label: 'Fabricação de aguardente de cana-de-açúcar',
      },
      {
        value: '1111902',
        label: 'Fabricação de outras aguardentes e bebidas destiladas',
      },
      {
        value: '1112700',
        label: 'Fabricação de vinho',
      },
      {
        value: '1113501',
        label: 'Fabricação de malte, inclusive malte uísque',
      },
      {
        value: '1113502',
        label: 'Fabricação de cervejas e chopes',
      },
      {
        value: '1121600',
        label: 'Fabricação de águas envasadas',
      },
      {
        value: '1122401',
        label: 'Fabricação de refrigerantes',
      },
      {
        value: '1122402',
        label: 'Fabricação de chá mate e outros chás prontos para consumo',
      },
      {
        value: '1122403',
        label:
          'Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas',
      },
      {
        value: '1122404',
        label: 'Fabricação de bebidas isotônicas',
      },
      {
        value: '1122499',
        label:
          'Fabricação de outras bebidas não-alcoólicas não especificadas anteriormente',
      },
      {
        value: '1210700',
        label: 'Processamento industrial do fumo',
      },
      {
        value: '1220401',
        label: 'Fabricação de cigarros',
      },
      {
        value: '1220402',
        label: 'Fabricação de cigarrilhas e charutos',
      },
      {
        value: '1220403',
        label: 'Fabricação de filtros para cigarros',
      },
      {
        value: '1220499',
        label:
          'Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos',
      },
      {
        value: '1311100',
        label: 'Preparação e fiação de fibras de algodão',
      },
      {
        value: '1312000',
        label: 'Preparação e fiação de fibras têxteis naturais, exceto algodão',
      },
      {
        value: '1313800',
        label: 'Fiação de fibras artificiais e sintéticas',
      },
      {
        value: '1314600',
        label: 'Fabricação de linhas para costurar e bordar',
      },
      {
        value: '1321900',
        label: 'Tecelagem de fios de algodão',
      },
      {
        value: '1322700',
        label: 'Tecelagem de fios de fibras têxteis naturais, exceto algodão',
      },
      {
        value: '1323500',
        label: 'Tecelagem de fios de fibras artificiais e sintéticas',
      },
      {
        value: '1330800',
        label: 'Fabricação de tecidos de malha',
      },
      {
        value: '1340501',
        label:
          'Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário',
      },
      {
        value: '1340502',
        label:
          'Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário',
      },
      {
        value: '1340599',
        label:
          'Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário',
      },
      {
        value: '1351100',
        label: 'Fabricação de artefatos têxteis para uso doméstico',
      },
      {
        value: '1352900',
        label: 'Fabricação de artefatos de tapeçaria',
      },
      {
        value: '1353700',
        label: 'Fabricação de artefatos de cordoaria',
      },
      {
        value: '1354500',
        label: 'Fabricação de tecidos especiais, inclusive artefatos',
      },
      {
        value: '1359600',
        label:
          'Fabricação de outros produtos têxteis não especificados anteriormente',
      },
      {
        value: '1411801',
        label: 'Confecção de roupas íntimas',
      },
      {
        value: '1411802',
        label: 'Facção de roupas íntimas',
      },
      {
        value: '1412601',
        label:
          'Confecção de peças de vestuário, exceto roupas íntimas e as confeccionadas sob medida',
      },
      {
        value: '1412602',
        label:
          'Confecção, sob medida, de peças do vestuário, exceto roupas íntimas',
      },
      {
        value: '1412603',
        label: 'Facção de peças do vestuário, exceto roupas íntimas',
      },
      {
        value: '1413401',
        label: 'Confecção de roupas profissionais, exceto sob medida',
      },
      {
        value: '1413402',
        label: 'Confecção, sob medida, de roupas profissionais',
      },
      {
        value: '1413403',
        label: 'Facção de roupas profissionais',
      },
      {
        value: '1414200',
        label:
          'Fabricação de acessórios do vestuário, exceto para segurança e proteção',
      },
      {
        value: '1421500',
        label: 'Fabricação de meias',
      },
      {
        value: '1422300',
        label:
          'Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias',
      },
      {
        value: '1510600',
        label: 'Curtimento e outras preparações de couro',
      },
      {
        value: '1521100',
        label:
          'Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material',
      },
      {
        value: '1529700',
        label:
          'Fabricação de artefatos de couro não especificados anteriormente',
      },
      {
        value: '1531901',
        label: 'Fabricação de calçados de couro',
      },
      {
        value: '1531902',
        label: 'Acabamento de calçados de couro sob contrato',
      },
      {
        value: '1532700',
        label: 'Fabricação de tênis de qualquer material',
      },
      {
        value: '1533500',
        label: 'Fabricação de calçados de material sintético',
      },
      {
        value: '1539400',
        label:
          'Fabricação de calçados de materiais não especificados anteriormente',
      },
      {
        value: '1540800',
        label: 'Fabricação de partes para calçados, de qualquer material',
      },
      {
        value: '1610201',
        label: 'Serrarias com desdobramento de madeira',
      },
      {
        value: '1610202',
        label: 'Serrarias sem desdobramento de madeira',
      },
      {
        value: '1610203',
        label: 'Serrarias com desdobramento de madeira em bruto',
      },
      {
        value: '1610204',
        label: 'Serrarias sem desdobramento de madeira em bruto  -Resserragem',
      },
      {
        value: '1610205',
        label: 'Serviço de tratamento de madeira realizado sob contrato',
      },
      {
        value: '1621800',
        label:
          'Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada',
      },
      {
        value: '1622601',
        label: 'Fabricação de casas de madeira pré-fabricadas',
      },
      {
        value: '1622602',
        label:
          'Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais',
      },
      {
        value: '1622699',
        label: 'Fabricação de outros artigos de carpintaria para construção',
      },
      {
        value: '1623400',
        label: 'Fabricação de artefatos de tanoaria e de embalagens de madeira',
      },
      {
        value: '1629301',
        label: 'Fabricação de artefatos diversos de madeira, exceto móveis',
      },
      {
        value: '1629302',
        label:
          'Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis',
      },
      {
        value: '1710900',
        label:
          'Fabricação de celulose e outras pastas para a fabricação de papel',
      },
      {
        value: '1721400',
        label: 'Fabricação de papel',
      },
      {
        value: '1722200',
        label: 'Fabricação de cartolina e papel-cartão',
      },
      {
        value: '1731100',
        label: 'Fabricação de embalagens de papel',
      },
      {
        value: '1732000',
        label: 'Fabricação de embalagens de cartolina e papel-cartão',
      },
      {
        value: '1733800',
        label: 'Fabricação de chapas e de embalagens de papelão ondulado',
      },
      {
        value: '1741901',
        label: 'Fabricação de formulários contínuos',
      },
      {
        value: '1741902',
        label:
          'Fabricação de produtos de papel, cartolina, papel cartão e papelão ondulado para uso comercial e de escritório, exceto formulário contínuo',
      },
      {
        value: '1742701',
        label: 'Fabricação de fraldas descartáveis',
      },
      {
        value: '1742702',
        label: 'Fabricação de absorventes higiênicos',
      },
      {
        value: '1742799',
        label:
          'Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente',
      },
      {
        value: '1749400',
        label:
          'Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente',
      },
      {
        value: '1811301',
        label: 'Impressão de jornais',
      },
      {
        value: '1811302',
        label: 'Impressão de livros, revistas e outras publicações periódicas',
      },
      {
        value: '1812100',
        label: 'Impressão de material de segurança',
      },
      {
        value: '1813001',
        label: 'Impressão de material para uso publicitário',
      },
      {
        value: '1813099',
        label: 'Impressão de material para outros usos',
      },
      {
        value: '1821100',
        label: 'Serviços de pré-impressão',
      },
      {
        value: '1822900',
        label: 'Serviços de acabamentos gráficos',
      },
      {
        value: '1822901',
        label: 'Serviços de encadernação e plastificação',
      },
      {
        value: '1822999',
        label:
          'Serviços de acabamentos gráficos, exceto encadernação e plastificação',
      },
      {
        value: '1830001',
        label: 'Reprodução de som em qualquer suporte',
      },
      {
        value: '1830002',
        label: 'Reprodução de vídeo em qualquer suporte',
      },
      {
        value: '1830003',
        label: 'Reprodução de software em qualquer suporte',
      },
      {
        value: '1910100',
        label: 'Coquerias',
      },
      {
        value: '1921700',
        label: 'Fabricação de produtos do refino de petróleo',
      },
      {
        value: '1922501',
        label: 'Formulação de combustíveis',
      },
      {
        value: '1922502',
        label: 'Rerrefino de óleos lubrificantes',
      },
      {
        value: '1922599',
        label:
          'Fabricação de outros produtos derivados do petróleo, exceto produtos do refino',
      },
      {
        value: '1931400',
        label: 'Fabricação de álcool',
      },
      {
        value: '1932200',
        label: 'Fabricação de biocombustíveis, exceto álcool',
      },
      {
        value: '2011800',
        label: 'Fabricação de cloro e álcalis',
      },
      {
        value: '2012600',
        label: 'Fabricação de intermediários para fertilizantes',
      },
      {
        value: '2013400',
        label: 'Fabricação de adubos e fertilizantes',
      },
      {
        value: '2013401',
        label: 'Fabricação de adubos e fertilizantes organo-minerais',
      },
      {
        value: '2013402',
        label: 'Fabricação de adubos e fertilizantes, exceto organo-minerais',
      },
      {
        value: '2014200',
        label: 'Fabricação de gases industriais',
      },
      {
        value: '2019301',
        label: 'Elaboração de combustíveis nucleares',
      },
      {
        value: '2019399',
        label:
          'Fabricação de outros produtos químicos inorgânicos não especificados anteriormente',
      },
      {
        value: '2021500',
        label: 'Fabricação de produtos petroquímicos básicos',
      },
      {
        value: '2022300',
        label:
          'Fabricação de intermediários para plastificantes, resinas e fibras',
      },
      {
        value: '2029100',
        label:
          'Fabricação de produtos químicos orgânicos não especificados anteriormente',
      },
      {
        value: '2031200',
        label: 'Fabricação de resinas termoplásticas',
      },
      {
        value: '2032100',
        label: 'Fabricação de resinas termofixas',
      },
      {
        value: '2033900',
        label: 'Fabricação de elastômeros',
      },
      {
        value: '2040100',
        label: 'Fabricação de fibras artificiais e sintéticas',
      },
      {
        value: '2051700',
        label: 'Fabricação de defensivos agrícolas',
      },
      {
        value: '2052500',
        label: 'Fabricação de desinfestantes domissanitários',
      },
      {
        value: '2061400',
        label: 'Fabricação de sabões e detergentes sintéticos',
      },
      {
        value: '2062200',
        label: 'Fabricação de produtos de limpeza e polimento',
      },
      {
        value: '2063100',
        label:
          'Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal',
      },
      {
        value: '2071100',
        label: 'Fabricação de tintas, vernizes, esmaltes e lacas',
      },
      {
        value: '2072000',
        label: 'Fabricação de tintas de impressão',
      },
      {
        value: '2073800',
        label: 'Fabricação de impermeabilizantes, solventes e produtos afins',
      },
      {
        value: '2091600',
        label: 'Fabricação de adesivos e selantes',
      },
      {
        value: '2092401',
        label: 'Fabricação de pólvoras, explosivos e detonantes',
      },
      {
        value: '2092402',
        label: 'Fabricação de artigos pirotécnicos',
      },
      {
        value: '2092403',
        label: 'Fabricação de fósforos de segurança',
      },
      {
        value: '2093200',
        label: 'Fabricação de aditivos de uso industrial',
      },
      {
        value: '2094100',
        label: 'Fabricação de catalisadores',
      },
      {
        value: '2099101',
        label:
          'Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia',
      },
      {
        value: '2099199',
        label:
          'Fabricação de outros produtos químicos não especificados anteriormente',
      },
      {
        value: '2110600',
        label: 'Fabricação de produtos farmoquímicos',
      },
      {
        value: '2121101',
        label: 'Fabricação de medicamentos alopáticos para uso humano',
      },
      {
        value: '2121102',
        label: 'Fabricação de medicamentos homeopáticos para uso humano',
      },
      {
        value: '2121103',
        label: 'Fabricação de medicamentos fitoterápicos para uso humano',
      },
      {
        value: '2122000',
        label: 'Fabricação de medicamentos para uso veterinário',
      },
      {
        value: '2123800',
        label: 'Fabricação de preparações farmacêuticas',
      },
      {
        value: '2211100',
        label: 'Fabricação de pneumáticos e de câmaras-de-ar',
      },
      {
        value: '2212900',
        label: 'Reforma de pneumáticos usados',
      },
      {
        value: '2219600',
        label:
          'Fabricação de artefatos de borracha não especificados anteriormente',
      },
      {
        value: '2221800',
        label:
          'Fabricação de laminados planos e tubulares de material plástico',
      },
      {
        value: '2222600',
        label: 'Fabricação de embalagens de material plástico',
      },
      {
        value: '2223400',
        label:
          'Fabricação de tubos e acessórios de material plástico para uso na construção',
      },
      {
        value: '2229301',
        label:
          'Fabricação de artefatos de material plástico para uso pessoal e doméstico',
      },
      {
        value: '2229302',
        label:
          'Fabricação de artefatos de material plástico para usos industriais',
      },
      {
        value: '2229303',
        label:
          'Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios',
      },
      {
        value: '2229399',
        label:
          'Fabricação de artefatos de material plástico para outros usos não especificados anteriormente',
      },
      {
        value: '2311700',
        label: 'Fabricação de vidro plano e de segurança',
      },
      {
        value: '2312500',
        label: 'Fabricação de embalagens de vidro',
      },
      {
        value: '2319200',
        label: 'Fabricação de artigos de vidro',
      },
      {
        value: '2320600',
        label: 'Fabricação de cimento',
      },
      {
        value: '2330301',
        label:
          'Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda',
      },
      {
        value: '2330302',
        label: 'Fabricação de artefatos de cimento para uso na construção',
      },
      {
        value: '2330303',
        label: 'Fabricação de artefatos de fibrocimento para uso na construção',
      },
      {
        value: '2330304',
        label: 'Fabricação de casas pré-moldadas de concreto',
      },
      {
        value: '2330305',
        label: 'Preparação de massa de concreto e argamassa para construção',
      },
      {
        value: '2330399',
        label:
          'Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais semelhantes',
      },
      {
        value: '2341900',
        label: 'Fabricação de produtos cerâmicos refratários',
      },
      {
        value: '2342701',
        label: 'Fabricação de azulejos e pisos',
      },
      {
        value: '2342702',
        label:
          'Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos',
      },
      {
        value: '2349401',
        label: 'Fabricação de material sanitário de cerâmica',
      },
      {
        value: '2349499',
        label:
          'Fabricação de produtos cerâmicos não-refratários não especificados anteriormente',
      },
      {
        value: '2391501',
        label: 'Britamento de pedras, exceto associado à extração',
      },
      {
        value: '2391502',
        label:
          'Aparelhamento de pedras para construção, exceto associado à extração',
      },
      {
        value: '2391503',
        label:
          'Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras',
      },
      {
        value: '2392300',
        label: 'Fabricação de cal e gesso',
      },
      {
        value: '2399101',
        label:
          'Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal',
      },
      {
        value: '2399102',
        label: 'Fabricação de abrasivos',
      },
      {
        value: '2399199',
        label:
          'Fabricação de outros produtos de minerais não-metálicos não especificados anteriormente',
      },
      {
        value: '2411300',
        label: 'Produção de ferro-gusa',
      },
      {
        value: '2412100',
        label: 'Produção de ferroligas',
      },
      {
        value: '2421100',
        label: 'Produção de semi-acabados de aço',
      },
      {
        value: '2422901',
        label:
          'Produção de laminados planos de aço ao carbono, revestidos ou não',
      },
      {
        value: '2422902',
        label: 'Produção de laminados planos de aços especiais',
      },
      {
        value: '2423701',
        label: 'Produção de tubos de aço sem costura',
      },
      {
        value: '2423702',
        label: 'Produção de laminados longos de aço, exceto tubos',
      },
      {
        value: '2424501',
        label: 'Produção de arames de aço',
      },
      {
        value: '2424502',
        label:
          'Produção de relaminados, trefilados e perfilados de aço, exceto arames',
      },
      {
        value: '2431800',
        label: 'Produção de tubos de aço com costura',
      },
      {
        value: '2439300',
        label: 'Produção de outros tubos de ferro e aço',
      },
      {
        value: '2441501',
        label: 'Produção de alumínio e suas ligas em formas primárias',
      },
      {
        value: '2441502',
        label: 'Produção de laminados de alumínio',
      },
      {
        value: '2442300',
        label: 'Metalurgia dos metais preciosos',
      },
      {
        value: '2443100',
        label: 'Metalurgia do cobre',
      },
      {
        value: '2449101',
        label: 'Produção de zinco em formas primárias',
      },
      {
        value: '2449102',
        label: 'Produção de laminados de zinco',
      },
      {
        value: '2449103',
        label: 'Fabricação de ânodos para galvanoplastia',
      },
      {
        value: '2449199',
        label:
          'Metalurgia de outros metais não-ferrosos e suas ligas não especificados anteriormente',
      },
      {
        value: '2451200',
        label: 'Fundição de ferro e aço',
      },
      {
        value: '2452100',
        label: 'Fundição de metais não-ferrosos e suas ligas',
      },
      {
        value: '2511000',
        label: 'Fabricação de estruturas metálicas',
      },
      {
        value: '2512800',
        label: 'Fabricação de esquadrias de metal',
      },
      {
        value: '2513600',
        label: 'Fabricação de obras de caldeiraria pesada',
      },
      {
        value: '2521700',
        label:
          'Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central',
      },
      {
        value: '2522500',
        label:
          'Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos',
      },
      {
        value: '2531401',
        label: 'Produção de forjados de aço',
      },
      {
        value: '2531402',
        label: 'Produção de forjados de metais não-ferrosos e suas ligas',
      },
      {
        value: '2532201',
        label: 'Produção de artefatos estampados de metal',
      },
      {
        value: '2532202',
        label: 'Metalurgia do pó',
      },
      {
        value: '2539000',
        label:
          'Serviços de usinagem, solda, tratamento e revestimento em metais',
      },
      {
        value: '2539001',
        label: 'Serviços de usinagem, tornearia e solda',
      },
      {
        value: '2539002',
        label: 'Serviços de tratamento e revestimento em metais',
      },
      {
        value: '2541100',
        label: 'Fabricação de artigos de cutelaria',
      },
      {
        value: '2542000',
        label: 'Fabricação de artigos de serralheria, exceto esquadrias',
      },
      {
        value: '2543800',
        label: 'Fabricação de ferramentas',
      },
      {
        value: '2550101',
        label:
          'Fabricação de equipamento bélico pesado, exceto veículos militares de combate',
      },
      {
        value: '2550102',
        label: 'Fabricação de armas de fogo, outras armas e munições',
      },
      {
        value: '2591800',
        label: 'Fabricação de embalagens metálicas',
      },
      {
        value: '2592601',
        label: 'Fabricação de produtos de trefilados de metal padronizados',
      },
      {
        value: '2592602',
        label:
          'Fabricação de produtos de trefilados de metal, exceto padronizados',
      },
      {
        value: '2593400',
        label: 'Fabricação de artigos de metal para uso doméstico e pessoal',
      },
      {
        value: '2599301',
        label: 'Serviços de confecção de armações metálicas para a construção',
      },
      {
        value: '2599302',
        label: 'Serviço de corte e dobra de metais',
      },
      {
        value: '2599399',
        label:
          'Fabricação de outros produtos de metal não especificados anteriormente',
      },
      {
        value: '2610800',
        label: 'Fabricação de componentes eletrônicos',
      },
      {
        value: '2621300',
        label: 'Fabricação de equipamentos de informática',
      },
      {
        value: '2622100',
        label: 'Fabricação de periféricos para equipamentos de informática',
      },
      {
        value: '2631100',
        label:
          'Fabricação de equipamentos transmissores de comunicação, peças e acessórios',
      },
      {
        value: '2632900',
        label:
          'Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios',
      },
      {
        value: '2640000',
        label:
          'Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo',
      },
      {
        value: '2651500',
        label:
          'Fabricação de aparelhos e equipamentos de medida, teste e controle',
      },
      {
        value: '2652300',
        label: 'Fabricação de cronômetros e relógios',
      },
      {
        value: '2660400',
        label:
          'Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação',
      },
      {
        value: '2670101',
        label:
          'Fabricação de equipamentos e instrumentos ópticos, peças e acessórios',
      },
      {
        value: '2670102',
        label:
          'Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios',
      },
      {
        value: '2680900',
        label: 'Fabricação de mídias virgens, magnéticas e ópticas',
      },
      {
        value: '2710401',
        label:
          'Fabricação de geradores de corrente contínua e alternada, peças e acessórios',
      },
      {
        value: '2710402',
        label:
          'Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios',
      },
      {
        value: '2710403',
        label: 'Fabricação de motores elétricos, peças e acessórios',
      },
      {
        value: '2721000',
        label:
          'Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores',
      },
      {
        value: '2722801',
        label:
          'Fabricação de baterias e acumuladores para veículos automotores',
      },
      {
        value: '2722802',
        label:
          'Recondicionamento de baterias e acumuladores para veículos automotores',
      },
      {
        value: '2731700',
        label:
          'Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica',
      },
      {
        value: '2732500',
        label:
          'Fabricação de material elétrico para instalações em circuito de consumo',
      },
      {
        value: '2733300',
        label: 'Fabricação de fios, cabos e condutores elétricos isolados',
      },
      {
        value: '2740601',
        label: 'Fabricação de lâmpadas',
      },
      {
        value: '2740602',
        label: 'Fabricação de luminárias e outros equipamentos de iluminação',
      },
      {
        value: '2751100',
        label:
          'Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessórios',
      },
      {
        value: '2759701',
        label:
          'Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios',
      },
      {
        value: '2759799',
        label:
          'Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios',
      },
      {
        value: '2790201',
        label:
          'Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs e isoladores',
      },
      {
        value: '2790202',
        label: 'Fabricação de equipamentos para sinalização e alarme',
      },
      {
        value: '2790299',
        label:
          'Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente',
      },
      {
        value: '2811900',
        label:
          'Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários',
      },
      {
        value: '2812700',
        label:
          'Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas',
      },
      {
        value: '2813500',
        label:
          'Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios',
      },
      {
        value: '2814301',
        label:
          'Fabricação de compressores para uso industrial, peças e acessórios',
      },
      {
        value: '2814302',
        label:
          'Fabricação de compressores para uso não industrial, peças e acessórios',
      },
      {
        value: '2815101',
        label: 'Fabricação de rolamentos para fins industriais',
      },
      {
        value: '2815102',
        label:
          'Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos',
      },
      {
        value: '2821601',
        label:
          'Fabricação de fornos industriais, aparelhos e equipamentos não-elétricos para instalações térmicas, peças e acessórios',
      },
      {
        value: '2821602',
        label:
          'Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios',
      },
      {
        value: '2822401',
        label:
          'Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e acessórios',
      },
      {
        value: '2822402',
        label:
          'Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acessórios',
      },
      {
        value: '2823200',
        label:
          'Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peças e acessórios',
      },
      {
        value: '2824101',
        label:
          'Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial',
      },
      {
        value: '2824102',
        label:
          'Fabricação de aparelhos e equipamentos de ar condicionado para uso não-industrial',
      },
      {
        value: '2825900',
        label:
          'Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios',
      },
      {
        value: '2829101',
        label:
          'Fabricação de máquinas de escrever, calcular e outros equipamentos não-eletrônicos para escritório, peças e acessórios',
      },
      {
        value: '2829199',
        label:
          'Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e acessórios',
      },
      {
        value: '2831300',
        label: 'Fabricação de tratores agrícolas, peças e acessórios',
      },
      {
        value: '2832100',
        label:
          'Fabricação de equipamentos para irrigação agrícola, peças e acessórios',
      },
      {
        value: '2833000',
        label:
          'Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para irrigação',
      },
      {
        value: '2840200',
        label: 'Fabricação de máquinas-ferramenta, peças e acessórios',
      },
      {
        value: '2851800',
        label:
          'Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios',
      },
      {
        value: '2852600',
        label:
          'Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, exceto na extração de petróleo',
      },
      {
        value: '2853400',
        label: 'Fabricação de tratores, peças e acessórios, exceto agrícolas',
      },
      {
        value: '2854200',
        label:
          'Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessórios, exceto tratores',
      },
      {
        value: '2861500',
        label:
          'Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta',
      },
      {
        value: '2862300',
        label:
          'Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acessórios',
      },
      {
        value: '2863100',
        label:
          'Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios',
      },
      {
        value: '2864000',
        label:
          'Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças e acessórios',
      },
      {
        value: '2865800',
        label:
          'Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, peças e acessórios',
      },
      {
        value: '2866600',
        label:
          'Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios',
      },
      {
        value: '2869100',
        label:
          'Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente, peças e acessórios',
      },
      {
        value: '2910701',
        label: 'Fabricação de automóveis, camionetas e utilitários',
      },
      {
        value: '2910702',
        label:
          'Fabricação de chassis com motor para automóveis, camionetas e utilitários',
      },
      {
        value: '2910703',
        label:
          'Fabricação de motores para automóveis, camionetas e utilitários',
      },
      {
        value: '2920401',
        label: 'Fabricação de caminhões e ônibus',
      },
      {
        value: '2920402',
        label: 'Fabricação de motores para caminhões e ônibus',
      },
      {
        value: '2930101',
        label: 'Fabricação de cabines, carrocerias e reboques para caminhões',
      },
      {
        value: '2930102',
        label: 'Fabricação de carrocerias para ônibus',
      },
      {
        value: '2930103',
        label:
          'Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ônibus',
      },
      {
        value: '2941700',
        label:
          'Fabricação de peças e acessórios para o sistema motor de veículos automotores',
      },
      {
        value: '2942500',
        label:
          'Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores',
      },
      {
        value: '2943300',
        label:
          'Fabricação de peças e acessórios para o sistema de freios de veículos automotores',
      },
      {
        value: '2944100',
        label:
          'Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores',
      },
      {
        value: '2945000',
        label:
          'Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias',
      },
      {
        value: '2949201',
        label: 'Fabricação de bancos e estofados para veículos automotores',
      },
      {
        value: '2949299',
        label:
          'Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente',
      },
      {
        value: '2950600',
        label:
          'Recondicionamento e recuperação de motores para veículos automotores',
      },
      {
        value: '3011301',
        label: 'Construção de embarcações de grande porte',
      },
      {
        value: '3011302',
        label:
          'Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte',
      },
      {
        value: '3012100',
        label: 'Construção de embarcações para esporte e lazer',
      },
      {
        value: '3031800',
        label: 'Fabricação de locomotivas, vagões e outros materiais rodantes',
      },
      {
        value: '3032600',
        label: 'Fabricação de peças e acessórios para veículos ferroviários',
      },
      {
        value: '3041500',
        label: 'Fabricação de aeronaves',
      },
      {
        value: '3042300',
        label:
          'Fabricação de turbinas, motores e outros componentes e peças para aeronaves',
      },
      {
        value: '3050400',
        label: 'Fabricação de veículos militares de combate',
      },
      {
        value: '3091100',
        label: 'Fabricação de motocicletas, peças e acessórios',
      },
      {
        value: '3091101',
        label: 'Fabricação de motocicletas',
      },
      {
        value: '3091102',
        label: 'Fabricação de peças e acessórios para motocicletas',
      },
      {
        value: '3092000',
        label:
          'Fabricação de bicicletas e triciclos não-motorizados, peças e acessórios',
      },
      {
        value: '3099700',
        label:
          'Fabricação de equipamentos de transporte não especificados anteriormente',
      },
      {
        value: '3101200',
        label: 'Fabricação de móveis com predominância de madeira',
      },
      {
        value: '3102100',
        label: 'Fabricação de móveis com predominância de metal',
      },
      {
        value: '3103900',
        label:
          'Fabricação de móveis de outros materiais, exceto madeira e metal',
      },
      {
        value: '3104700',
        label: 'Fabricação de colchões',
      },
      {
        value: '3211601',
        label: 'Lapidação de gemas',
      },
      {
        value: '3211602',
        label: 'Fabricação de artefatos de joalheria e ourivesaria',
      },
      {
        value: '3211603',
        label: 'Cunhagem de moedas e medalhas',
      },
      {
        value: '3212400',
        label: 'Fabricação de bijuterias e artefatos semelhantes',
      },
      {
        value: '3220500',
        label: 'Fabricação de instrumentos musicais, peças e acessórios',
      },
      {
        value: '3230200',
        label: 'Fabricação de artefatos para pesca e esporte',
      },
      {
        value: '3240001',
        label: 'Fabricação de jogos eletrônicos',
      },
      {
        value: '3240002',
        label:
          'Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação',
      },
      {
        value: '3240003',
        label:
          'Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação',
      },
      {
        value: '3240099',
        label:
          'Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente',
      },
      {
        value: '3250701',
        label:
          'Fabricação de instrumentos não-eletrônicos e utensílios para uso médico, cirúrgico, odontológico e de laboratório',
      },
      {
        value: '3250702',
        label:
          'Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório',
      },
      {
        value: '3250703',
        label:
          'Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda',
      },
      {
        value: '3250704',
        label:
          'Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral, exceto sob encomenda',
      },
      {
        value: '3250705',
        label: 'Fabricação de materiais para medicina e odontologia',
      },
      {
        value: '3250706',
        label: 'Serviços de prótese dentária',
      },
      {
        value: '3250707',
        label: 'Fabricação de artigos ópticos',
      },
      {
        value: '3250708',
        label:
          'Fabricação de artefatos de tecido não tecido para uso odonto-médico-hospitalar',
      },
      {
        value: '3250709',
        label: 'Serviço de laboratório óptico',
      },
      {
        value: '3291400',
        label: 'Fabricação de escovas, pincéis e vassouras',
      },
      {
        value: '3292201',
        label:
          'Fabricação de roupas de proteção e segurança e resistentes a fogo',
      },
      {
        value: '3292202',
        label:
          'Fabricação de equipamentos e acessórios para segurança pessoal e profissional',
      },
      {
        value: '3299001',
        label: 'Fabricação de guarda-chuvas e similares',
      },
      {
        value: '3299002',
        label: 'Fabricação de canetas, lápis e outros artigos para escritório',
      },
      {
        value: '3299003',
        label:
          'Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos',
      },
      {
        value: '3299004',
        label: 'Fabricação de painéis e letreiros luminosos',
      },
      {
        value: '3299005',
        label: 'Fabricação de aviamentos para costura',
      },
      {
        value: '3299006',
        label: 'Fabricação de velas, inclusive decorativas',
      },
      {
        value: '3299099',
        label:
          'Fabricação de produtos diversos não especificados anteriormente',
      },
      {
        value: '3311200',
        label:
          'Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos',
      },
      {
        value: '3312101',
        label:
          'Manutenção e reparação de equipamentos transmissores de comunicação',
      },
      {
        value: '3312102',
        label:
          'Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle',
      },
      {
        value: '3312103',
        label:
          'Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação',
      },
      {
        value: '3312104',
        label: 'Manutenção e reparação de equipamentos e instrumentos ópticos',
      },
      {
        value: '3313901',
        label:
          'Manutenção e reparação de geradores, transformadores e motores elétricos',
      },
      {
        value: '3313902',
        label:
          'Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos',
      },
      {
        value: '3313999',
        label:
          'Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente',
      },
      {
        value: '3314701',
        label: 'Manutenção e reparação de máquinas motrizes não-elétricas',
      },
      {
        value: '3314702',
        label:
          'Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas',
      },
      {
        value: '3314703',
        label: 'Manutenção e reparação de válvulas industriais',
      },
      {
        value: '3314704',
        label: 'Manutenção e reparação de compressores',
      },
      {
        value: '3314705',
        label:
          'Manutenção e reparação de equipamentos de transmissão para fins industriais',
      },
      {
        value: '3314706',
        label:
          'Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas',
      },
      {
        value: '3314707',
        label:
          'Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial',
      },
      {
        value: '3314708',
        label:
          'Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas',
      },
      {
        value: '3314709',
        label:
          'Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não-eletrônicos para escritório',
      },
      {
        value: '3314710',
        label:
          'Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente',
      },
      {
        value: '3314711',
        label:
          'Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária',
      },
      {
        value: '3314712',
        label: 'Manutenção e reparação de tratores agrícolas',
      },
      {
        value: '3314713',
        label: 'Manutenção e reparação de máquinas-ferramenta',
      },
      {
        value: '3314714',
        label:
          'Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo',
      },
      {
        value: '3314715',
        label:
          'Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo',
      },
      {
        value: '3314716',
        label: 'Manutenção e reparação de tratores, exceto agrícolas',
      },
      {
        value: '3314717',
        label:
          'Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores',
      },
      {
        value: '3314718',
        label:
          'Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta',
      },
      {
        value: '3314719',
        label:
          'Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo',
      },
      {
        value: '3314720',
        label:
          'Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados',
      },
      {
        value: '3314721',
        label:
          'Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos',
      },
      {
        value: '3314722',
        label:
          'Manutenção e reparação de máquinas e aparelhos para a indústria do plástico',
      },
      {
        value: '3314799',
        label:
          'Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente',
      },
      {
        value: '3315500',
        label: 'Manutenção e reparação de veículos ferroviários',
      },
      {
        value: '3316301',
        label:
          'Manutenção e reparação de aeronaves, exceto a manutenção na pista',
      },
      {
        value: '3316302',
        label: 'Manutenção de aeronaves na pista',
      },
      {
        value: '3317101',
        label: 'Manutenção e reparação de embarcações e estruturas flutuantes',
      },
      {
        value: '3317102',
        label: 'Manutenção e reparação de embarcações para esporte e lazer',
      },
      {
        value: '3319800',
        label:
          'Manutenção e reparação de equipamentos e produtos não especificados anteriormente',
      },
      {
        value: '3321000',
        label: 'Instalação de máquinas e equipamentos industriais',
      },
      {
        value: '3329501',
        label: 'Serviços de montagem de móveis de qualquer material',
      },
      {
        value: '3329599',
        label:
          'Instalação de outros equipamentos não especificados anteriormente',
      },
      {
        value: '3511500',
        label: 'Geração de energia elétrica',
      },
      {
        value: '3511501',
        label: 'Geração de energia elétrica',
      },
      {
        value: '3511502',
        label:
          'Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica',
      },
      {
        value: '3512300',
        label: 'Transmissão de energia elétrica',
      },
      {
        value: '3513100',
        label: 'Comércio atacadista de energia elétrica',
      },
      {
        value: '3514000',
        label: 'Distribuição de energia elétrica',
      },
      {
        value: '3520401',
        label: 'Produção de gás; processamento de gás natural',
      },
      {
        value: '3520402',
        label: 'Distribuição de combustíveis gasosos por redes urbanas',
      },
      {
        value: '3530100',
        label:
          'Produção e distribuição de vapor, água quente e ar condicionado',
      },
      {
        value: '3600601',
        label: 'Captação, tratamento e distribuição de água',
      },
      {
        value: '3600602',
        label: 'Distribuição de água por caminhões',
      },
      {
        value: '3701100',
        label: 'Gestão de redes de esgoto',
      },
      {
        value: '3702900',
        label: 'Atividades relacionadas a esgoto, exceto a gestão de redes',
      },
      {
        value: '3811400',
        label: 'Coleta de resíduos não-perigosos',
      },
      {
        value: '3812200',
        label: 'Coleta de resíduos perigosos',
      },
      {
        value: '3821100',
        label: 'Tratamento e disposição de resíduos não-perigosos',
      },
      {
        value: '3822000',
        label: 'Tratamento e disposição de resíduos perigosos',
      },
      {
        value: '3831901',
        label: 'Recuperação de sucatas de alumínio',
      },
      {
        value: '3831999',
        label: 'Recuperação de materiais metálicos, exceto alumínio',
      },
      {
        value: '3832700',
        label: 'Recuperação de materiais plásticos',
      },
      {
        value: '3839401',
        label: 'Usinas de compostagem',
      },
      {
        value: '3839499',
        label: 'Recuperação de materiais não especificados anteriormente',
      },
      {
        value: '3900500',
        label: 'Descontaminação e outros serviços de gestão de resíduos',
      },
      {
        value: '4110700',
        label: 'Incorporação de empreendimentos imobiliários',
      },
      {
        value: '4120400',
        label: 'Construção de edifícios',
      },
      {
        value: '4211101',
        label: 'Construção de rodovias e ferrovias',
      },
      {
        value: '4211102',
        label: 'Pintura para sinalização em pistas rodoviárias e aeroportos',
      },
      {
        value: '4212000',
        label: 'Construção de obras de arte especiais',
      },
      {
        value: '4213800',
        label: 'Obras de urbanização - ruas, praças e calçadas',
      },
      {
        value: '4221901',
        label:
          'Construção de barragens e represas para geração de energia elétrica',
      },
      {
        value: '4221902',
        label:
          'Construção de estações e redes de distribuição de energia elétrica',
      },
      {
        value: '4221903',
        label: 'Manutenção de redes de distribuição de energia elétrica',
      },
      {
        value: '4221904',
        label: 'Construção de estações e redes de telecomunicações',
      },
      {
        value: '4221905',
        label: 'Manutenção de estações e redes de telecomunicações',
      },
      {
        value: '4222701',
        label:
          'Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação',
      },
      {
        value: '4222702',
        label: 'Obras de irrigação',
      },
      {
        value: '4223500',
        label:
          'Construção de redes de transportes por dutos, exceto para água e esgoto',
      },
      {
        value: '4291000',
        label: 'Obras portuárias, marítimas e fluviais',
      },
      {
        value: '4292801',
        label: 'Montagem de estruturas metálicas',
      },
      {
        value: '4292802',
        label: 'Obras de montagem industrial',
      },
      {
        value: '4299501',
        label: 'Construção de instalações esportivas e recreativas',
      },
      {
        value: '4299599',
        label:
          'Outras obras de engenharia civil não especificadas anteriormente',
      },
      {
        value: '4311801',
        label: 'Demolição de edifícios e outras estruturas',
      },
      {
        value: '4311802',
        label: 'Preparação de canteiro e limpeza de terreno',
      },
      {
        value: '4312600',
        label: 'Perfurações e sondagens',
      },
      {
        value: '4313400',
        label: 'Obras de terraplenagem',
      },
      {
        value: '4319300',
        label:
          'Serviços de preparação do terreno não especificados anteriormente',
      },
      {
        value: '4321500',
        label: 'Instalação e manutenção elétrica',
      },
      {
        value: '4322301',
        label: 'Instalações hidráulicas, sanitárias e de gás',
      },
      {
        value: '4322302',
        label:
          'Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração',
      },
      {
        value: '4322303',
        label: 'Instalações de sistema de prevenção contra incêndio',
      },
      {
        value: '4329101',
        label: 'Instalação de painéis publicitários',
      },
      {
        value: '4329102',
        label:
          'Instalação de equipamentos para orientação à navegação marítima fluvial e lacustre',
      },
      {
        value: '4329103',
        label:
          'Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes',
      },
      {
        value: '4329104',
        label:
          'Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos',
      },
      {
        value: '4329105',
        label: 'Tratamentos térmicos, acústicos ou de vibração',
      },
      {
        value: '4329199',
        label:
          'Outras obras de instalações em construções não especificadas anteriormente',
      },
      {
        value: '4330401',
        label: 'Impermeabilização em obras de engenharia civil',
      },
      {
        value: '4330402',
        label:
          'Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material',
      },
      {
        value: '4330403',
        label: 'Obras de acabamento em gesso e estuque',
      },
      {
        value: '4330404',
        label: 'Serviços de pintura de edifícios em geral',
      },
      {
        value: '4330405',
        label:
          'Aplicação de revestimentos e de resinas em interiores e exteriores',
      },
      {
        value: '4330499',
        label: 'Outras obras de acabamento da construção',
      },
      {
        value: '4391600',
        label: 'Obras de fundações',
      },
      {
        value: '4399101',
        label: 'Administração de obras',
      },
      {
        value: '4399102',
        label:
          'Montagem e desmontagem de andaimes e outras estruturas temporárias',
      },
      {
        value: '4399103',
        label: 'Obras de alvenaria',
      },
      {
        value: '4399104',
        label:
          'Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras',
      },
      {
        value: '4399105',
        label: 'Perfuração e construção de poços de água',
      },
      {
        value: '4399199',
        label:
          'Serviços especializados para construção não especificados anteriormente',
      },
      {
        value: '4511101',
        label:
          'Comércio a varejo de automóveis, camionetas e utilitários novos',
      },
      {
        value: '4511102',
        label:
          'Comércio a varejo de automóveis, camionetas e utilitários usados',
      },
      {
        value: '4511103',
        label:
          'Comércio por atacado de automóveis, camionetas e utilitários novos e usados',
      },
      {
        value: '4511104',
        label: 'Comércio por atacado de caminhões novos e usados',
      },
      {
        value: '4511105',
        label:
          'Comércio por atacado de reboques e semi-reboques novos e usados',
      },
      {
        value: '4511106',
        label: 'Comércio por atacado de ônibus e microônibus novos e usados',
      },
      {
        value: '4512901',
        label:
          'Representantes comerciais e agentes do comércio de veículos automotores',
      },
      {
        value: '4512902',
        label: 'Comércio sob consignação de veículos automotores',
      },
      {
        value: '4520001',
        label:
          'Serviços de manutenção e reparação mecânica de veículos automotores',
      },
      {
        value: '4520002',
        label:
          'Serviços de lanternagem ou funilaria e pintura de veículos automotores',
      },
      {
        value: '4520003',
        label:
          'Serviços de manutenção e reparação elétrica de veículos automotores',
      },
      {
        value: '4520004',
        label:
          'Serviços de alinhamento e balanceamento de veículos automotores',
      },
      {
        value: '4520005',
        label:
          'Serviços de lavagem, lubrificação e polimento de veículos automotores',
      },
      {
        value: '4520006',
        label: 'Serviços de borracharia para veículos automotores',
      },
      {
        value: '4520007',
        label:
          'Serviços de instalação, manutenção e reparação de acessórios para veículos automotores',
      },
      {
        value: '4520008',
        label: 'Serviços de capotaria',
      },
      {
        value: '4530701',
        label:
          'Comércio por atacado de peças e acessórios novos para veículos automotores',
      },
      {
        value: '4530702',
        label: 'Comércio por atacado de pneumáticos e câmaras-de-ar',
      },
      {
        value: '4530703',
        label:
          'Comércio a varejo de peças e acessórios novos para veículos automotores',
      },
      {
        value: '4530704',
        label:
          'Comércio a varejo de peças e acessórios usados para veículos automotores',
      },
      {
        value: '4530705',
        label: 'Comércio a varejo de pneumáticos e câmaras-de-ar',
      },
      {
        value: '4530706',
        label:
          'Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores',
      },
      {
        value: '4541201',
        label: 'Comércio por atacado de motocicletas e motonetas',
      },
      {
        value: '4541202',
        label:
          'Comércio por atacado de peças e acessórios para motocicletas e motonetas',
      },
      {
        value: '4541203',
        label: 'Comércio a varejo de motocicletas e motonetas novas',
      },
      {
        value: '4541204',
        label: 'Comércio a varejo de motocicletas e motonetas usadas',
      },
      {
        value: '4541205',
        label:
          'Comércio a varejo de peças e acessórios para motocicletas e motonetas',
      },
      {
        value: '4541206',
        label:
          'Comércio a varejo de peças e acessórios novos para  motocicletas e motonetas',
      },
      {
        value: '4541207',
        label:
          'Comércio a varejo de peças e acessórios usados para motocicletas e motonetas',
      },
      {
        value: '4542101',
        label:
          'Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios',
      },
      {
        value: '4542102',
        label: 'Comércio sob consignação de motocicletas e motonetas',
      },
      {
        value: '4543900',
        label: 'Manutenção e reparação de motocicletas e motonetas',
      },
      {
        value: '4611700',
        label:
          'Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos',
      },
      {
        value: '4612500',
        label:
          'Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos',
      },
      {
        value: '4613300',
        label:
          'Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens',
      },
      {
        value: '4614100',
        label:
          'Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves',
      },
      {
        value: '4615000',
        label:
          'Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico',
      },
      {
        value: '4616800',
        label:
          'Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem',
      },
      {
        value: '4617600',
        label:
          'Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo',
      },
      {
        value: '4618401',
        label:
          'Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria',
      },
      {
        value: '4618402',
        label:
          'Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalares',
      },
      {
        value: '4618403',
        label:
          'Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações',
      },
      {
        value: '4618499',
        label:
          'Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente',
      },
      {
        value: '4619200',
        label:
          'Representantes comerciais e agentes do comércio de mercadorias em geral não especializado',
      },
      {
        value: '4621400',
        label: 'Comércio atacadista de café em grão',
      },
      {
        value: '4622200',
        label: 'Comércio atacadista de soja',
      },
      {
        value: '4623101',
        label: 'Comércio atacadista de animais vivos',
      },
      {
        value: '4623102',
        label:
          'Comércio atacadista de couros, lãs, peles e outros subprodutos não-comestíveis de origem animal',
      },
      {
        value: '4623103',
        label: 'Comércio atacadista de algodão',
      },
      {
        value: '4623104',
        label: 'Comércio atacadista de fumo em folha não beneficiado',
      },
      {
        value: '4623105',
        label: 'Comércio atacadista de cacau',
      },
      {
        value: '4623106',
        label: 'Comércio atacadista de sementes, flores, plantas e gramas',
      },
      {
        value: '4623107',
        label: 'Comércio atacadista de sisal',
      },
      {
        value: '4623108',
        label:
          'Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento associada',
      },
      {
        value: '4623109',
        label: 'Comércio atacadista de alimentos para animais',
      },
      {
        value: '4623199',
        label:
          'Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente',
      },
      {
        value: '4631100',
        label: 'Comércio atacadista de leite e laticínios',
      },
      {
        value: '4632001',
        label: 'Comércio atacadista de cereais e leguminosas beneficiados',
      },
      {
        value: '4632002',
        label: 'Comércio atacadista de farinhas, amidos e féculas',
      },
      {
        value: '4632003',
        label:
          'Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas, com atividade de fracionamento e acondicionamento associada',
      },
      {
        value: '4633801',
        label:
          'Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos',
      },
      {
        value: '4633802',
        label: 'Comércio atacadista de aves vivas e ovos',
      },
      {
        value: '4633803',
        label:
          'Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação',
      },
      {
        value: '4634601',
        label: 'Comércio atacadista de carnes bovinas e suínas e derivados',
      },
      {
        value: '4634602',
        label: 'Comércio atacadista de aves abatidas e derivados',
      },
      {
        value: '4634603',
        label: 'Comércio atacadista de pescados e frutos do mar',
      },
      {
        value: '4634699',
        label: 'Comércio atacadista de carnes e derivados de outros animais',
      },
      {
        value: '4635401',
        label: 'Comércio atacadista de água mineral',
      },
      {
        value: '4635402',
        label: 'Comércio atacadista de cerveja, chope e refrigerante',
      },
      {
        value: '4635403',
        label:
          'Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada',
      },
      {
        value: '4635499',
        label: 'Comércio atacadista de bebidas não especificadas anteriormente',
      },
      {
        value: '4636201',
        label: 'Comércio atacadista de fumo beneficiado',
      },
      {
        value: '4636202',
        label: 'Comércio atacadista de cigarros, cigarrilhas e charutos',
      },
      {
        value: '4637101',
        label: 'Comércio atacadista de café torrado, moído e solúvel',
      },
      {
        value: '4637102',
        label: 'Comércio atacadista de açúcar',
      },
      {
        value: '4637103',
        label: 'Comércio atacadista de óleos e gorduras',
      },
      {
        value: '4637104',
        label: 'Comércio atacadista de pães, bolos, biscoitos e similares',
      },
      {
        value: '4637105',
        label: 'Comércio atacadista de massas alimentícias',
      },
      {
        value: '4637106',
        label: 'Comércio atacadista de sorvetes',
      },
      {
        value: '4637107',
        label:
          'Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes',
      },
      {
        value: '4637199',
        label:
          'Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente',
      },
      {
        value: '4639701',
        label: 'Comércio atacadista de produtos alimentícios em geral',
      },
      {
        value: '4639702',
        label:
          'Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionamento associada',
      },
      {
        value: '4641901',
        label: 'Comércio atacadista de tecidos',
      },
      {
        value: '4641902',
        label: 'Comércio atacadista de artigos de cama, mesa e banho',
      },
      {
        value: '4641903',
        label: 'Comércio atacadista de artigos de armarinho',
      },
      {
        value: '4642701',
        label:
          'Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança',
      },
      {
        value: '4642702',
        label:
          'Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho',
      },
      {
        value: '4643501',
        label: 'Comércio atacadista de calçados',
      },
      {
        value: '4643502',
        label: 'Comércio atacadista de bolsas, malas e artigos de viagem',
      },
      {
        value: '4644301',
        label: 'Comércio atacadista de medicamentos e drogas de uso humano',
      },
      {
        value: '4644302',
        label:
          'Comércio atacadista de medicamentos e drogas de uso veterinário',
      },
      {
        value: '4645101',
        label:
          'Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laboratórios',
      },
      {
        value: '4645102',
        label: 'Comércio atacadista de próteses e artigos de ortopedia',
      },
      {
        value: '4645103',
        label: 'Comércio atacadista de produtos odontológicos',
      },
      {
        value: '4646001',
        label: 'Comércio atacadista de cosméticos e produtos de perfumaria',
      },
      {
        value: '4646002',
        label: 'Comércio atacadista de produtos de higiene pessoal',
      },
      {
        value: '4647801',
        label: 'Comércio atacadista de artigos de escritório e de papelaria',
      },
      {
        value: '4647802',
        label: 'Comércio atacadista de livros, jornais e outras publicações',
      },
      {
        value: '4649401',
        label:
          'Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico',
      },
      {
        value: '4649402',
        label:
          'Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico',
      },
      {
        value: '4649403',
        label:
          'Comércio atacadista de bicicletas, triciclos e outros veículos recreativos',
      },
      {
        value: '4649404',
        label: 'Comércio atacadista de móveis e artigos de colchoaria',
      },
      {
        value: '4649405',
        label:
          'Comércio atacadista de artigos de tapeçaria; persianas e cortinas',
      },
      {
        value: '4649406',
        label: 'Comércio atacadista de lustres, luminárias e abajures',
      },
      {
        value: '4649407',
        label: 'Comércio atacadista de filmes, CDs, DVDs, fitas e discos',
      },
      {
        value: '4649408',
        label:
          'Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar',
      },
      {
        value: '4649409',
        label:
          'Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar, com atividade de fracionamento e acondicionamento associada',
      },
      {
        value: '4649410',
        label:
          'Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapidadas',
      },
      {
        value: '4649499',
        label:
          'Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente',
      },
      {
        value: '4651601',
        label: 'Comércio atacadista de equipamentos de informática',
      },
      {
        value: '4651602',
        label: 'Comércio atacadista de suprimentos para informática',
      },
      {
        value: '4652400',
        label:
          'Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação',
      },
      {
        value: '4661300',
        label:
          'Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças',
      },
      {
        value: '4662100',
        label:
          'Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças',
      },
      {
        value: '4663000',
        label:
          'Comércio atacadista de Máquinas e equipamentos para uso industrial; partes e peças',
      },
      {
        value: '4664800',
        label:
          'Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças',
      },
      {
        value: '4665600',
        label:
          'Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças',
      },
      {
        value: '4669901',
        label: 'Comércio atacadista de bombas e compressores; partes e peças',
      },
      {
        value: '4669999',
        label:
          'Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peças',
      },
      {
        value: '4671100',
        label: 'Comércio atacadista de madeira e produtos derivados',
      },
      {
        value: '4672900',
        label: 'Comércio atacadista de ferragens e ferramentas',
      },
      {
        value: '4673700',
        label: 'Comércio atacadista de material elétrico',
      },
      {
        value: '4674500',
        label: 'Comércio atacadista de cimento',
      },
      {
        value: '4679601',
        label: 'Comércio atacadista de tintas, vernizes e similares',
      },
      {
        value: '4679602',
        label: 'Comércio atacadista de mármores e granitos',
      },
      {
        value: '4679603',
        label: 'Comércio atacadista de vidros, espelhos, vitrais e molduras',
      },
      {
        value: '4679604',
        label:
          'Comércio atacadista especializado de materiais de construção não especificados anteriormente',
      },
      {
        value: '4679699',
        label: 'Comércio atacadista de materiais de construção em geral',
      },
      {
        value: '4681801',
        label:
          'Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto lubrificantes, não realizado por transportador re',
      },
      {
        value: '4681802',
        label:
          'Comércio atacadista de combustíveis realizado por transportador retalhista (T.R.R.)',
      },
      {
        value: '4681803',
        label:
          'Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante',
      },
      {
        value: '4681804',
        label: 'Comércio atacadista de combustíveis de origem mineral em bruto',
      },
      {
        value: '4681805',
        label: 'Comércio atacadista de lubrificantes',
      },
      {
        value: '4682600',
        label: 'Comércio atacadista de gás liqüefeito de petróleo (GLP)',
      },
      {
        value: '4683400',
        label:
          'Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo',
      },
      {
        value: '4684201',
        label: 'Comércio atacadista de resinas e elastômeros',
      },
      {
        value: '4684202',
        label: 'Comércio atacadista de solventes',
      },
      {
        value: '4684299',
        label:
          'Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente',
      },
      {
        value: '4685100',
        label:
          'Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção',
      },
      {
        value: '4686901',
        label: 'Comércio atacadista de papel e papelão em bruto',
      },
      {
        value: '4686902',
        label: 'Comércio atacadista de embalagens',
      },
      {
        value: '4687701',
        label: 'Comércio atacadista de resíduos de papel e papelão',
      },
      {
        value: '4687702',
        label:
          'Comércio atacadista de resíduos e sucatas não-metálicos, exceto de papel e papelão',
      },
      {
        value: '4687703',
        label: 'Comércio atacadista de resíduos e sucatas metálicos',
      },
      {
        value: '4689301',
        label:
          'Comércio atacadista de produtos da extração mineral, exceto combustíveis',
      },
      {
        value: '4689302',
        label: 'Comércio atacadista de fios e fibras beneficiados',
      },
      {
        value: '4689399',
        label:
          'Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente',
      },
      {
        value: '4691500',
        label:
          'Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios',
      },
      {
        value: '4692300',
        label:
          'Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários',
      },
      {
        value: '4693100',
        label:
          'Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários',
      },
      {
        value: '4711301',
        label:
          'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados',
      },
      {
        value: '4711302',
        label:
          'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercados',
      },
      {
        value: '4712100',
        label:
          'Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercados, mercearias e armazéns',
      },
      {
        value: '4713001',
        label: 'Lojas de departamentos ou magazines',
      },
      {
        value: '4713002',
        label:
          'Lojas de variedades, exceto lojas de departamentos ou magazines',
      },
      {
        value: '4713003',
        label: 'Lojas duty free de aeroportos internacionais',
      },
      {
        value: '4713004',
        label:
          'Lojas de departamentos ou magazines, exceto lojas francas (Duty free)',
      },
      {
        value: '4713005',
        label:
          'Lojas francas (Duty free) de aeroportos, portos e em fronteiras terrestres',
      },
      {
        value: '4721101',
        label: 'Padaria e confeitaria com predominância de produção própria',
      },
      {
        value: '4721102',
        label: 'Padaria e confeitaria com predominância de revenda',
      },
      {
        value: '4721103',
        label: 'Comércio varejista de laticínios e frios',
      },
      {
        value: '4721104',
        label: 'Comércio varejista de doces, balas, bombons e semelhantes',
      },
      {
        value: '4722901',
        label: 'Comércio varejista de carnes - açougues',
      },
      {
        value: '4722902',
        label: 'Peixaria',
      },
      {
        value: '4723700',
        label: 'Comércio varejista de bebidas',
      },
      {
        value: '4724500',
        label: 'Comércio varejista de hortifrutigranjeiros',
      },
      {
        value: '4729601',
        label: 'Tabacaria',
      },
      {
        value: '4729602',
        label: 'Comércio varejista de mercadorias em lojas de conveniência',
      },
      {
        value: '4729699',
        label:
          'Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente',
      },
      {
        value: '4731800',
        label: 'Comércio varejista de combustíveis para veículos automotores',
      },
      {
        value: '4732600',
        label: 'Comércio varejista de lubrificantes',
      },
      {
        value: '4741500',
        label: 'Comércio varejista de tintas e materiais para pintura',
      },
      {
        value: '4742300',
        label: 'Comércio varejista de material elétrico',
      },
      {
        value: '4743100',
        label: 'Comércio varejista de vidros',
      },
      {
        value: '4744001',
        label: 'Comércio varejista de ferragens e ferramentas',
      },
      {
        value: '4744002',
        label: 'Comércio varejista de madeira e artefatos',
      },
      {
        value: '4744003',
        label: 'Comércio varejista de materiais hidráulicos',
      },
      {
        value: '4744004',
        label:
          'Comércio varejista de cal, areia, pedra britada, tijolos e telhas',
      },
      {
        value: '4744005',
        label:
          'Comércio varejista de materiais de construção não especificados anteriormente',
      },
      {
        value: '4744006',
        label: 'Comércio varejista de pedras para revestimento',
      },
      {
        value: '4744099',
        label: 'Comércio varejista de materiais de construção em geral',
      },
      {
        value: '4751200',
        label:
          'Comércio varejista especializado de equipamentos e suprimentos de informática',
      },
      {
        value: '4751201',
        label:
          'Comércio varejista especializado de equipamentos e suprimentos de informática',
      },
      {
        value: '4751202',
        label: 'Recarga de cartuchos para equipamentos de informática',
      },
      {
        value: '4752100',
        label:
          'Comércio varejista especializado de equipamentos de telefonia e comunicação',
      },
      {
        value: '4753900',
        label:
          'Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo',
      },
      {
        value: '4754701',
        label: 'Comércio varejista de móveis',
      },
      {
        value: '4754702',
        label: 'Comércio varejista de artigos de colchoaria',
      },
      {
        value: '4754703',
        label: 'Comércio varejista de artigos de iluminação',
      },
      {
        value: '4755501',
        label: 'Comércio varejista de tecidos',
      },
      {
        value: '4755502',
        label: 'Comercio varejista de artigos de armarinho',
      },
      {
        value: '4755503',
        label: 'Comercio varejista de artigos de cama, mesa e banho',
      },
      {
        value: '4756300',
        label:
          'Comércio varejista especializado de instrumentos musicais e acessórios',
      },
      {
        value: '4757100',
        label:
          'Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação',
      },
      {
        value: '4759801',
        label:
          'Comércio varejista de artigos de tapeçaria, cortinas e persianas',
      },
      {
        value: '4759899',
        label:
          'Comércio varejista de outros artigos de uso pessoal e doméstico não especificados anteriormente',
      },
      {
        value: '4761001',
        label: 'Comércio varejista de livros',
      },
      {
        value: '4761002',
        label: 'Comércio varejista de jornais e revistas',
      },
      {
        value: '4761003',
        label: 'Comércio varejista de artigos de papelaria',
      },
      {
        value: '4762800',
        label: 'Comércio varejista de discos, CDs, DVDs e fitas',
      },
      {
        value: '4763601',
        label: 'Comércio varejista de brinquedos e artigos recreativos',
      },
      {
        value: '4763602',
        label: 'Comércio varejista de artigos esportivos',
      },
      {
        value: '4763603',
        label:
          'Comércio varejista de bicicletas e triciclos; peças e acessórios',
      },
      {
        value: '4763604',
        label: 'Comércio varejista de artigos de caça, pesca e camping',
      },
      {
        value: '4763605',
        label:
          'Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios',
      },
      {
        value: '4771701',
        label:
          'Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas',
      },
      {
        value: '4771702',
        label:
          'Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas',
      },
      {
        value: '4771703',
        label: 'Comércio varejista de produtos farmacêuticos homeopáticos',
      },
      {
        value: '4771704',
        label: 'Comércio varejista de medicamentos veterinários',
      },
      {
        value: '4772500',
        label:
          'Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal',
      },
      {
        value: '4773300',
        label: 'Comércio varejista de artigos médicos e ortopédicos',
      },
      {
        value: '4774100',
        label: 'Comércio varejista de artigos de óptica',
      },
      {
        value: '4781400',
        label: 'Comércio varejista de artigos do vestuário e acessórios',
      },
      {
        value: '4782201',
        label: 'Comércio varejista de calçados',
      },
      {
        value: '4782202',
        label: 'Comércio varejista de artigos de viagem',
      },
      {
        value: '4783101',
        label: 'Comércio varejista de artigos de joalheria',
      },
      {
        value: '4783102',
        label: 'Comércio varejista de artigos de relojoaria',
      },
      {
        value: '4784900',
        label: 'Comércio varejista de gás liqüefeito de petróleo (GLP)',
      },
      {
        value: '4785701',
        label: 'Comércio varejista de antigüidades',
      },
      {
        value: '4785799',
        label: 'Comércio varejista de outros artigos usados',
      },
      {
        value: '4789001',
        label: 'Comércio varejista de suvenires, bijuterias e artesanatos',
      },
      {
        value: '4789002',
        label: 'Comércio varejista de plantas e flores naturais',
      },
      {
        value: '4789003',
        label: 'Comércio varejista de objetos de arte',
      },
      {
        value: '4789004',
        label:
          'Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação',
      },
      {
        value: '4789005',
        label: 'Comércio varejista de produtos saneantes domissanitários',
      },
      {
        value: '4789006',
        label:
          'Comércio varejista de fogos de artifício e artigos pirotécnicos',
      },
      {
        value: '4789007',
        label: 'Comércio varejista de equipamentos para escritório',
      },
      {
        value: '4789008',
        label: 'Comércio varejista de artigos fotográficos e para filmagem',
      },
      {
        value: '4789009',
        label: 'Comércio varejista de armas e munições',
      },
      {
        value: '4789099',
        label:
          'Comércio varejista de outros produtos não especificados anteriormente',
      },
      {
        value: '4911600',
        label: 'Transporte ferroviário de carga',
      },
      {
        value: '4912401',
        label:
          'Transporte ferroviário de passageiros intermunicipal e interestadual',
      },
      {
        value: '4912402',
        label:
          'Transporte ferroviário de passageiros municipal e em região metropolitana',
      },
      {
        value: '4912403',
        label: 'Transporte metroviário',
      },
      {
        value: '4921301',
        label:
          'Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal',
      },
      {
        value: '4921302',
        label:
          'Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropolitana',
      },
      {
        value: '4922101',
        label:
          'Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região metropolitana',
      },
      {
        value: '4922102',
        label:
          'Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual',
      },
      {
        value: '4922103',
        label:
          'Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional',
      },
      {
        value: '4923001',
        label: 'Serviço de táxi',
      },
      {
        value: '4923002',
        label:
          'Serviço de transporte de passageiros - locação de automóveis com motorista',
      },
      {
        value: '4924800',
        label: 'Transporte escolar',
      },
      {
        value: '4929901',
        label:
          'Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal',
      },
      {
        value: '4929902',
        label:
          'Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadual e internacional',
      },
      {
        value: '4929903',
        label:
          'Organização de excursões em veículos rodoviários próprios, municipal',
      },
      {
        value: '4929904',
        label:
          'Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional',
      },
      {
        value: '4929999',
        label:
          'Outros transportes rodoviários de passageiros não especificados anteriormente',
      },
      {
        value: '4930201',
        label:
          'Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal.',
      },
      {
        value: '4930202',
        label:
          'Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional',
      },
      {
        value: '4930203',
        label: 'Transporte rodoviário de produtos perigosos',
      },
      {
        value: '4930204',
        label: 'Transporte rodoviário de mudanças',
      },
      {
        value: '4940000',
        label: 'Transporte dutoviário',
      },
      {
        value: '4950700',
        label: 'Trens turísticos, teleféricos e similares',
      },
      {
        value: '5011401',
        label: 'Transporte marítimo de cabotagem - Carga',
      },
      {
        value: '5011402',
        label: 'Transporte marítimo de cabotagem - passageiros',
      },
      {
        value: '5012201',
        label: 'Transporte marítimo de longo curso - Carga',
      },
      {
        value: '5012202',
        label: 'Transporte marítimo de longo curso - Passageiros',
      },
      {
        value: '5021101',
        label:
          'Transporte por navegação interior de carga, municipal, exceto travessia',
      },
      {
        value: '5021102',
        label:
          'Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia',
      },
      {
        value: '5022001',
        label:
          'Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia',
      },
      {
        value: '5022002',
        label:
          'Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual e internacional, exceto travessia',
      },
      {
        value: '5030101',
        label: 'Navegação de apoio marítimo',
      },
      {
        value: '5030102',
        label: 'Navegação de apoio portuário',
      },
      {
        value: '5030103',
        label: 'Serviço de rebocadores e empurradores',
      },
      {
        value: '5091201',
        label: 'Transporte por navegação de travessia, municipal',
      },
      {
        value: '5091202',
        label:
          'Transporte por navegação de travessia intermunicipal, interestadual e internacional',
      },
      {
        value: '5099801',
        label: 'Transporte aquaviário para passeios turísticos',
      },
      {
        value: '5099899',
        label: 'Outros transportes aquaviários não especificados anteriormente',
      },
      {
        value: '5111100',
        label: 'Transporte aéreo de passageiros regular',
      },
      {
        value: '5112901',
        label: 'Serviço de táxi aéreo e locação de aeronaves com tripulação',
      },
      {
        value: '5112999',
        label: 'Outros serviços de transporte aéreo de passageiros não-regular',
      },
      {
        value: '5120000',
        label: 'Transporte aéreo de carga',
      },
      {
        value: '5130700',
        label: 'Transporte espacial',
      },
      {
        value: '5211701',
        label: 'Armazéns gerais - emissão de warrant',
      },
      {
        value: '5211702',
        label: 'Guarda-móveis',
      },
      {
        value: '5211799',
        label:
          'Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis',
      },
      {
        value: '5212500',
        label: 'Carga e descarga',
      },
      {
        value: '5221400',
        label:
          'Concessionárias de rodovias, pontes, túneis e serviços relacionados',
      },
      {
        value: '5222200',
        label: 'Terminais rodoviários e ferroviários',
      },
      {
        value: '5223100',
        label: 'Estacionamento de veículos',
      },
      {
        value: '5229001',
        label:
          'Serviços de apoio ao transporte por táxi, inclusive centrais de chamada',
      },
      {
        value: '5229002',
        label: 'Serviços de reboque de veículos',
      },
      {
        value: '5229099',
        label:
          'Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente',
      },
      {
        value: '5231101',
        label: 'Administração da infra-estrutura portuária',
      },
      {
        value: '5231102',
        label: 'Atividades do Operador Portuário',
      },
      {
        value: '5231103',
        label: 'Gestão de terminais aquaviários',
      },
      {
        value: '5232000',
        label: 'Atividades de agenciamento marítimo',
      },
      {
        value: '5239700',
        label:
          'Atividades auxiliares dos transportes aquaviários não especificadas anteriormente',
      },
      {
        value: '5239701',
        label: 'Serviços de praticagem',
      },
      {
        value: '5239799',
        label:
          'Atividades auxiliares dos transportes aquaviários não especificadas anteriormente',
      },
      {
        value: '5240101',
        label: 'Operação dos aeroportos e campos de aterrissagem',
      },
      {
        value: '5240199',
        label:
          'Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem',
      },
      {
        value: '5250801',
        label: 'Comissaria de despachos',
      },
      {
        value: '5250802',
        label: 'Atividades de despachantes aduaneiros',
      },
      {
        value: '5250803',
        label: 'Agenciamento de cargas, exceto para o transporte marítimo',
      },
      {
        value: '5250804',
        label: 'Organização logística do transporte de carga',
      },
      {
        value: '5250805',
        label: 'Operador de transporte multimodal - OTM',
      },
      {
        value: '5310501',
        label: 'Atividades do Correio Nacional',
      },
      {
        value: '5310502',
        label: 'Atividades de franqueadas do Correio Nacional',
      },
      {
        value: '5320201',
        label: 'Serviços de malote não realizados pelo Correio Nacional',
      },
      {
        value: '5320202',
        label: 'Serviços de entrega rápida',
      },
      {
        value: '5510801',
        label: 'Hotéis',
      },
      {
        value: '5510802',
        label: 'Apart-hotéis',
      },
      {
        value: '5510803',
        label: 'Motéis',
      },
      {
        value: '5590601',
        label: 'Albergues, exceto assistenciais',
      },
      {
        value: '5590602',
        label: 'Campings',
      },
      {
        value: '5590603',
        label: 'Pensões (alojamento)',
      },
      {
        value: '5590699',
        label: 'Outros alojamentos não especificados anteriormente',
      },
      {
        value: '5611201',
        label: 'Restaurantes e similares',
      },
      {
        value: '5611202',
        label:
          'Bares e outros estabelecimentos especializados em servir bebidas',
      },
      {
        value: '5611203',
        label: 'Lanchonetes, casas de chá, de sucos e similares',
      },
      {
        value: '5611204',
        label:
          'Bares e outros estabelecimentos especializados em servir bebidas, sem entretenimento',
      },
      {
        value: '5611205',
        label:
          'Bares e outros estabelecimentos especializados em servir bebidas, com entretenimento',
      },
      {
        value: '5612100',
        label: 'Serviços ambulantes de alimentação',
      },
      {
        value: '5620101',
        label:
          'Fornecimento de alimentos preparados preponderantemente para empresas',
      },
      {
        value: '5620102',
        label: 'Serviços de alimentação para eventos e recepções - bufê',
      },
      {
        value: '5620103',
        label: 'Cantinas - serviços de alimentação privativos',
      },
      {
        value: '5620104',
        label:
          'Fornecimento de alimentos preparados preponderantemente para consumo domiciliar',
      },
      {
        value: '5811500',
        label: 'Edição de livros',
      },
      {
        value: '5812300',
        label: 'Edição de jornais',
      },
      {
        value: '5812301',
        label: 'Edição de jornais diários',
      },
      {
        value: '5812302',
        label: 'Edição de jornais não diários',
      },
      {
        value: '5813100',
        label: 'Edição de revistas',
      },
      {
        value: '5819100',
        label: 'Edição de cadastros, listas e de outros produtos gráficos',
      },
      {
        value: '5821200',
        label: 'Edição integrada à impressão de livros',
      },
      {
        value: '5822100',
        label: 'Edição integrada à impressão de jornais',
      },
      {
        value: '5822101',
        label: 'Edição integrada à impressão de jornais diários',
      },
      {
        value: '5822102',
        label: 'Edição integrada à impressão de jornais não diários',
      },
      {
        value: '5823900',
        label: 'Edição integrada à impressão de revistas',
      },
      {
        value: '5829800',
        label:
          'Edição integrada à impressão de cadastros, listas e de outros produtos gráficos',
      },
      {
        value: '5911101',
        label: 'Estúdios cinematográficos',
      },
      {
        value: '5911102',
        label: 'Produção de filmes para publicidade',
      },
      {
        value: '5911199',
        label:
          'Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente',
      },
      {
        value: '5912001',
        label: 'Serviços de dublagem',
      },
      {
        value: '5912002',
        label: 'Serviços de mixagem sonora em produção audiovisual',
      },
      {
        value: '5912099',
        label:
          'Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente',
      },
      {
        value: '5913800',
        label:
          'Distribuição cinematográfica, de vídeo e de programas de televisão',
      },
      {
        value: '5914600',
        label: 'Atividades de exibição cinematográfica',
      },
      {
        value: '5920100',
        label: 'Atividades de gravação de som e de edição de música',
      },
      {
        value: '6010100',
        label: 'Atividades de rádio',
      },
      {
        value: '6021700',
        label: 'Atividades de televisão aberta',
      },
      {
        value: '6022501',
        label: 'Programadoras',
      },
      {
        value: '6022502',
        label:
          'Atividades relacionadas à televisão por assinatura, exceto programadoras',
      },
      {
        value: '6110801',
        label: 'Serviços de telefonia fixa comutada - STFC',
      },
      {
        value: '6110802',
        label: 'Serviços de redes de transportes de telecomunicações - SRTT',
      },
      {
        value: '6110803',
        label: 'Serviços de comunicação multimídia - SCM',
      },
      {
        value: '6110899',
        label:
          'Serviços de telecomunicações por fio não especificados anteriormente',
      },
      {
        value: '6120501',
        label: 'Telefonia móvel celular',
      },
      {
        value: '6120502',
        label: 'Serviço móvel especializado - SME',
      },
      {
        value: '6120599',
        label:
          'Serviços de telecomunicações sem fio não especificados anteriormente',
      },
      {
        value: '6130200',
        label: 'Telecomunicações por satélite',
      },
      {
        value: '6141800',
        label: 'Operadoras de televisão por assinatura por cabo',
      },
      {
        value: '6142600',
        label: 'Operadoras de televisão por assinatura por microondas',
      },
      {
        value: '6143400',
        label: 'Operadoras de televisão por assinatura por satélite',
      },
      {
        value: '6190601',
        label: 'Provedores de acesso às redes de comunicações',
      },
      {
        value: '6190602',
        label: 'Provedores de voz sobre protocolo internet - VOIP',
      },
      {
        value: '6190699',
        label:
          'Outras atividades de telecomunicações não especificadas anteriormente',
      },
      {
        value: '6201500',
        label: 'Desenvolvimento de programas de computador sob encomenda',
      },
      {
        value: '6201501',
        label: 'Desenvolvimento de programas de computador sob encomenda',
      },
      {
        value: '6201502',
        label: 'Web design',
      },
      {
        value: '6202300',
        label:
          'Desenvolvimento e licenciamento de programas de computador customizáveis',
      },
      {
        value: '6203100',
        label:
          'Desenvolvimento e licenciamento de programas de computador não-customizáveis',
      },
      {
        value: '6204000',
        label: 'Consultoria em tecnologia da informação',
      },
      {
        value: '6209100',
        label:
          'Suporte técnico, manutenção e outros serviços em tecnologia da informação',
      },
      {
        value: '6311900',
        label:
          'Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet',
      },
      {
        value: '6319400',
        label:
          'Portais, provedores de conteúdo e outros serviços de informação na internet',
      },
      {
        value: '6391700',
        label: 'Agências de notícias',
      },
      {
        value: '6399200',
        label:
          'Outras atividades de prestação de serviços de informação não especificadas anteriormente',
      },
      {
        value: '6410700',
        label: 'Banco Central',
      },
      {
        value: '6421200',
        label: 'Bancos comerciais',
      },
      {
        value: '6422100',
        label: 'Bancos múltiplos, com carteira comercial',
      },
      {
        value: '6423900',
        label: 'Caixas econômicas',
      },
      {
        value: '6424701',
        label: 'Bancos cooperativos',
      },
      {
        value: '6424702',
        label: 'Cooperativas centrais de crédito',
      },
      {
        value: '6424703',
        label: 'Cooperativas de crédito mútuo',
      },
      {
        value: '6424704',
        label: 'Cooperativas de crédito rural',
      },
      {
        value: '6431000',
        label: 'Bancos múltiplos, sem carteira comercial',
      },
      {
        value: '6432800',
        label: 'Bancos de investimento',
      },
      {
        value: '6433600',
        label: 'Bancos de desenvolvimento',
      },
      {
        value: '6434400',
        label: 'Agências de fomento',
      },
      {
        value: '6435201',
        label: 'Sociedades de crédito imobiliário',
      },
      {
        value: '6435202',
        label: 'Associações de poupança e empréstimo',
      },
      {
        value: '6435203',
        label: 'Companhias hipotecárias',
      },
      {
        value: '6436100',
        label:
          'Sociedades de crédito, financiamento e investimento - financeiras',
      },
      {
        value: '6437900',
        label: 'Sociedades de crédito ao microempreendedor',
      },
      {
        value: '6438701',
        label: 'Bancos de câmbio',
      },
      {
        value: '6438799',
        label:
          'Outras instituições de intermediação não-monetária não especificadas anteriormente',
      },
      {
        value: '6440900',
        label: 'Arrendamento mercantil',
      },
      {
        value: '6450600',
        label: 'Sociedades de capitalização',
      },
      {
        value: '6461100',
        label: 'Holdings de instituições financeiras',
      },
      {
        value: '6462000',
        label: 'Holdings de instituições não-financeiras',
      },
      {
        value: '6463800',
        label: 'Outras sociedades de participação, exceto holdings',
      },
      {
        value: '6470101',
        label: 'Fundos de investimento, exceto previdenciários e imobiliários',
      },
      {
        value: '6470102',
        label: 'Fundos de investimento previdenciários',
      },
      {
        value: '6470103',
        label: 'Fundos de investimento imobiliários',
      },
      {
        value: '6491300',
        label: 'Sociedades de fomento mercantil - factoring',
      },
      {
        value: '6492100',
        label: 'Securitização de créditos',
      },
      {
        value: '6493000',
        label: 'Administração de consórcios para aquisição de bens e direitos',
      },
      {
        value: '6499901',
        label: 'Clubes de investimento',
      },
      {
        value: '6499902',
        label: 'Sociedades de investimento',
      },
      {
        value: '6499903',
        label: 'Fundo garantidor de crédito',
      },
      {
        value: '6499904',
        label: 'Caixas de financiamento de corporações',
      },
      {
        value: '6499905',
        label: 'Concessão de crédito pelas OSCIP',
      },
      {
        value: '6499999',
        label:
          'Outras atividades de serviços financeiros não especificadas anteriormente',
      },
      {
        value: '6511101',
        label: 'Sociedade seguradora de seguros vida',
      },
      {
        value: '6511102',
        label: 'Planos de auxílio-funeral',
      },
      {
        value: '6512000',
        label: 'Sociedade seguradora de seguros não vida',
      },
      {
        value: '6520100',
        label: 'Sociedade seguradora de seguros saúde',
      },
      {
        value: '6530800',
        label: 'Resseguros',
      },
      {
        value: '6541300',
        label: 'Previdência complementar fechada',
      },
      {
        value: '6542100',
        label: 'Previdência complementar aberta',
      },
      {
        value: '6550200',
        label: 'Planos de saúde',
      },
      {
        value: '6611801',
        label: 'Bolsa de valores',
      },
      {
        value: '6611802',
        label: 'Bolsa de mercadorias',
      },
      {
        value: '6611803',
        label: 'Bolsa de mercadorias e futuros',
      },
      {
        value: '6611804',
        label: 'Administração de mercados de balcão organizados',
      },
      {
        value: '6612601',
        label: 'Corretoras de títulos e valores mobiliários',
      },
      {
        value: '6612602',
        label: 'Distribuidoras de títulos e valores mobiliários',
      },
      {
        value: '6612603',
        label: 'Corretoras de câmbio',
      },
      {
        value: '6612604',
        label: 'Corretoras de contratos de mercadorias',
      },
      {
        value: '6612605',
        label: 'Agentes de investimentos em aplicações financeiras',
      },
      {
        value: '6613400',
        label: 'Administração de cartões de crédito',
      },
      {
        value: '6619301',
        label: 'Serviços de liquidação e custódia',
      },
      {
        value: '6619302',
        label: 'Correspondentes de instituições financeiras',
      },
      {
        value: '6619303',
        label: 'Representações de bancos estrangeiros',
      },
      {
        value: '6619304',
        label: 'Caixas eletrônicos',
      },
      {
        value: '6619305',
        label: 'Operadoras de cartões de débito',
      },
      {
        value: '6619399',
        label:
          'Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente',
      },
      {
        value: '6621501',
        label: 'Peritos e avaliadores de seguros',
      },
      {
        value: '6621502',
        label: 'Auditoria e consultoria atuarial',
      },
      {
        value: '6622300',
        label:
          'Corretores e agentes de seguros, de planos de previdência complementar e de saúde',
      },
      {
        value: '6629100',
        label:
          'Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente',
      },
      {
        value: '6630400',
        label: 'Atividades de administração de fundos por contrato ou comissão',
      },
      {
        value: '6810201',
        label: 'Compra e venda de imóveis próprios',
      },
      {
        value: '6810202',
        label: 'Aluguel de imóveis próprios',
      },
      {
        value: '6810203',
        label: 'Loteamento de imóveis próprios',
      },
      {
        value: '6821801',
        label: 'Corretagem na compra e venda e avaliação de imóveis',
      },
      {
        value: '6821802',
        label: 'Corretagem no aluguel de imóveis',
      },
      {
        value: '6822600',
        label: 'Gestão e administração da propriedade imobiliária',
      },
      {
        value: '6911701',
        label: 'Serviços advocatícios',
      },
      {
        value: '6911702',
        label: 'Atividades auxiliares da justiça',
      },
      {
        value: '6911703',
        label: 'Agente de propriedade industrial',
      },
      {
        value: '6912500',
        label: 'Cartórios',
      },
      {
        value: '6920601',
        label: 'Atividades de contabilidade',
      },
      {
        value: '6920602',
        label: 'Atividades de consultoria e auditoria contábil e tributária',
      },
      {
        value: '7020400',
        label:
          'Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica',
      },
      {
        value: '7111100',
        label: 'Serviços de arquitetura',
      },
      {
        value: '7112000',
        label: 'Serviços de engenharia',
      },
      {
        value: '7119701',
        label: 'Serviços de cartografia, topografia e geodésia',
      },
      {
        value: '7119702',
        label: 'Atividades de estudos geológicos',
      },
      {
        value: '7119703',
        label:
          'Serviços de desenho técnico relacionados à arquitetura e engenharia',
      },
      {
        value: '7119704',
        label:
          'Serviços de perícia técnica relacionados à segurança do trabalho',
      },
      {
        value: '7119799',
        label:
          'Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente',
      },
      {
        value: '7120100',
        label: 'Testes e análises técnicas',
      },
      {
        value: '7210000',
        label:
          'Pesquisa e desenvolvimento experimental em ciências físicas e naturais',
      },
      {
        value: '7220700',
        label:
          'Pesquisa e desenvolvimento experimental em ciências sociais e humanas',
      },
      {
        value: '7311400',
        label: 'Agências de publicidade',
      },
      {
        value: '7312200',
        label:
          'Agenciamento de espaços para publicidade, exceto em veículos de comunicação',
      },
      {
        value: '7319001',
        label: 'Criação de estandes para feiras e exposições',
      },
      {
        value: '7319002',
        label: 'Promoção de vendas',
      },
      {
        value: '7319003',
        label: 'Marketing direto',
      },
      {
        value: '7319004',
        label: 'Consultoria em publicidade',
      },
      {
        value: '7319099',
        label:
          'Outras atividades de publicidade não especificadas anteriormente',
      },
      {
        value: '7320300',
        label: 'Pesquisas de mercado e de opinião pública',
      },
      {
        value: '7410201',
        label: 'Design',
      },
      {
        value: '7410202',
        label: 'Design de interiores',
      },
      {
        value: '7410203',
        label: 'Design de produto',
      },
      {
        value: '7410299',
        label: 'atividades de design não especificadas anteriormente',
      },
      {
        value: '7420001',
        label:
          'Atividades de produção de fotografias, exceto aérea e submarina',
      },
      {
        value: '7420002',
        label: 'Atividades de produção de fotografias aéreas e submarinas',
      },
      {
        value: '7420003',
        label: 'Laboratórios fotográficos',
      },
      {
        value: '7420004',
        label: 'Filmagem de festas e eventos',
      },
      {
        value: '7420005',
        label: 'Serviços de microfilmagem',
      },
      {
        value: '7490101',
        label: 'Serviços de tradução, interpretação e similares',
      },
      {
        value: '7490102',
        label: 'Escafandria e mergulho',
      },
      {
        value: '7490103',
        label:
          'Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias',
      },
      {
        value: '7490104',
        label:
          'Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários',
      },
      {
        value: '7490105',
        label:
          'Agenciamento de profissionais para atividades esportivas, culturais e artísticas',
      },
      {
        value: '7490199',
        label:
          'Outras atividades profissionais, científicas e técnicas não especificadas anteriormente',
      },
      {
        value: '7500100',
        label: 'Atividades veterinárias',
      },
      {
        value: '7711000',
        label: 'Locação de automóveis sem condutor',
      },
      {
        value: '7719501',
        label:
          'Locação de embarcações sem tripulação, exceto para fins recreativos',
      },
      {
        value: '7719502',
        label: 'Locação de aeronaves sem tripulação',
      },
      {
        value: '7719599',
        label:
          'Locação de outros meios de transporte não especificados anteriormente, sem condutor',
      },
      {
        value: '7721700',
        label: 'Aluguel de equipamentos recreativos e esportivos',
      },
      {
        value: '7722500',
        label: 'Aluguel de fitas de vídeo, DVDs e similares',
      },
      {
        value: '7723300',
        label: 'Aluguel de objetos do vestuário, jóias e acessórios',
      },
      {
        value: '7729201',
        label: 'Aluguel de aparelhos de jogos eletrônicos',
      },
      {
        value: '7729202',
        label:
          'Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais',
      },
      {
        value: '7729203',
        label: 'Aluguel de material médico',
      },
      {
        value: '7729299',
        label:
          'Aluguel de outros objetos pessoais e domésticos não especificados anteriormente',
      },
      {
        value: '7731400',
        label: 'Aluguel de máquinas e equipamentos agrícolas sem operador',
      },
      {
        value: '7732201',
        label:
          'Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes',
      },
      {
        value: '7732202',
        label: 'Aluguel de andaimes',
      },
      {
        value: '7733100',
        label: 'Aluguel de máquinas e equipamentos para escritórios',
      },
      {
        value: '7739001',
        label:
          'Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador',
      },
      {
        value: '7739002',
        label:
          'Aluguel de equipamentos científicos, médicos e hospitalares, sem operador',
      },
      {
        value: '7739003',
        label:
          'Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes',
      },
      {
        value: '7739099',
        label:
          'Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, sem operador',
      },
      {
        value: '7740300',
        label: 'Gestão de ativos intangíveis não-financeiros',
      },
      {
        value: '7810800',
        label: 'Seleção e agenciamento de mão-de-obra',
      },
      {
        value: '7820500',
        label: 'Locação de mão-de-obra temporária',
      },
      {
        value: '7830200',
        label: 'Fornecimento e gestão de recursos humanos para terceiros',
      },
      {
        value: '7911200',
        label: 'Agências de viagens',
      },
      {
        value: '7912100',
        label: 'Operadores turísticos',
      },
      {
        value: '7990200',
        label:
          'Serviços de reservas e outros serviços de turismo não especificados anteriormente',
      },
      {
        value: '8011101',
        label: 'Atividades de vigilância e segurança privada',
      },
      {
        value: '8011102',
        label: 'Serviços de adestramento de cães de guarda',
      },
      {
        value: '8012900',
        label: 'Atividades de transporte de valores',
      },
      {
        value: '8020000',
        label: 'Atividades de monitoramento de sistemas de segurança',
      },
      {
        value: '8020001',
        label:
          'Atividades de monitoramento de sistemas de segurança eletrônico',
      },
      {
        value: '8020002',
        label: 'Outras atividades de serviços de segurança',
      },
      {
        value: '8030700',
        label: 'Atividades de investigação particular',
      },
      {
        value: '8111700',
        label:
          'Serviços combinados para apoio a edifícios, exceto condomínios prediais',
      },
      {
        value: '8112500',
        label: 'Condomínios prediais',
      },
      {
        value: '8121400',
        label: 'Limpeza em prédios e em domicílios',
      },
      {
        value: '8122200',
        label: 'Imunização e controle de pragas urbanas',
      },
      {
        value: '8129000',
        label: 'Atividades de limpeza não especificadas anteriormente',
      },
      {
        value: '8130300',
        label: 'Atividades paisagísticas',
      },
      {
        value: '8211300',
        label: 'Serviços combinados de escritório e apoio administrativo',
      },
      {
        value: '8219901',
        label: 'Fotocópias',
      },
      {
        value: '8219999',
        label:
          'Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente',
      },
      {
        value: '8220200',
        label: 'Atividades de teleatendimento',
      },
      {
        value: '8230001',
        label:
          'Serviços de organização de feiras, congressos, exposições e festas',
      },
      {
        value: '8230002',
        label: 'Casas de festas e eventos',
      },
      {
        value: '8291100',
        label: 'Atividades de cobranças e informações cadastrais',
      },
      {
        value: '8292000',
        label: 'Envasamento e empacotamento sob contrato',
      },
      {
        value: '8299701',
        label: 'Medição de consumo de energia elétrica, gás e água',
      },
      {
        value: '8299702',
        label: 'Emissão de vales-alimentação, vales-transporte e similares',
      },
      {
        value: '8299703',
        label: 'Serviços de gravação de carimbos, exceto confecção',
      },
      {
        value: '8299704',
        label: 'Leiloeiros independentes',
      },
      {
        value: '8299705',
        label: 'Serviços de levantamento de fundos sob contrato',
      },
      {
        value: '8299706',
        label: 'Casas lotéricas',
      },
      {
        value: '8299707',
        label: 'Salas de acesso à internet',
      },
      {
        value: '8299799',
        label:
          'Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente',
      },
      {
        value: '8411600',
        label: 'Administração pública em geral',
      },
      {
        value: '8412400',
        label:
          'Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais',
      },
      {
        value: '8413200',
        label: 'Regulação das atividades econômicas',
      },
      {
        value: '8421300',
        label: 'Relações exteriores',
      },
      {
        value: '8422100',
        label: 'Defesa',
      },
      {
        value: '8423000',
        label: 'Justiça',
      },
      {
        value: '8424800',
        label: 'Segurança e ordem pública',
      },
      {
        value: '8425600',
        label: 'Defesa Civil',
      },
      {
        value: '8430200',
        label: 'Seguridade social obrigatória',
      },
      {
        value: '8511200',
        label: 'Educação infantil - creche',
      },
      {
        value: '8512100',
        label: 'Educação infantil - pré-escola',
      },
      {
        value: '8513900',
        label: 'Ensino fundamental',
      },
      {
        value: '8520100',
        label: 'Ensino médio',
      },
      {
        value: '8531700',
        label: 'Educação superior - graduação',
      },
      {
        value: '8532500',
        label: 'Educação superior - graduação e pós-graduação',
      },
      {
        value: '8533300',
        label: 'Educação superior - pós-graduação e extensão',
      },
      {
        value: '8541400',
        label: 'Educação profissional de nível técnico',
      },
      {
        value: '8542200',
        label: 'Educação profissional de nível tecnológico',
      },
      {
        value: '8550301',
        label: 'Administração de caixas escolares',
      },
      {
        value: '8550302',
        label: 'Atividades de apoio à educação, exceto caixas escolares',
      },
      {
        value: '8591100',
        label: 'Ensino de esportes',
      },
      {
        value: '8592901',
        label: 'Ensino de dança',
      },
      {
        value: '8592902',
        label: 'Ensino de artes cênicas, exceto dança',
      },
      {
        value: '8592903',
        label: 'Ensino de música',
      },
      {
        value: '8592999',
        label: 'Ensino de arte e cultura não especificado anteriormente',
      },
      {
        value: '8593700',
        label: 'Ensino de idiomas',
      },
      {
        value: '8599601',
        label: 'Formação de condutores',
      },
      {
        value: '8599602',
        label: 'Cursos de pilotagem',
      },
      {
        value: '8599603',
        label: 'Treinamento em informática',
      },
      {
        value: '8599604',
        label: 'Treinamento em desenvolvimento profissional e gerencial',
      },
      {
        value: '8599605',
        label: 'Cursos preparatórios para concursos',
      },
      {
        value: '8599699',
        label: 'Outras atividades de ensino não especificadas anteriormente',
      },
      {
        value: '8610101',
        label:
          'Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências',
      },
      {
        value: '8610102',
        label:
          'Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências',
      },
      {
        value: '8621601',
        label: 'UTI móvel',
      },
      {
        value: '8621602',
        label:
          'Serviços móveis de atendimento a urgências, exceto por UTI móvel',
      },
      {
        value: '8622400',
        label:
          'Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências',
      },
      {
        value: '8630501',
        label:
          'Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos',
      },
      {
        value: '8630502',
        label:
          'Atividade médica ambulatorial com recursos para realização de exames complementares',
      },
      {
        value: '8630503',
        label: 'Atividade médica ambulatorial restrita a consultas',
      },
      {
        value: '8630504',
        label: 'Atividade odontológica',
      },
      {
        value: '8630505',
        label:
          'Atividade odontológica sem recursos para realização de procedimentos cirúrgicos',
      },
      {
        value: '8630506',
        label: 'Serviços de vacinação e imunização humana',
      },
      {
        value: '8630507',
        label: 'Atividades de reprodução humana assistida',
      },
      {
        value: '8630599',
        label:
          'Atividades de atenção ambulatorial não especificadas anteriormente',
      },
      {
        value: '8640201',
        label: 'Laboratórios de anatomia patológica e citológica',
      },
      {
        value: '8640202',
        label: 'Laboratórios clínicos',
      },
      {
        value: '8640203',
        label: 'Serviços de diálise e nefrologia',
      },
      {
        value: '8640204',
        label: 'Serviços de tomografia',
      },
      {
        value: '8640205',
        label:
          'Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia',
      },
      {
        value: '8640206',
        label: 'Serviços de ressonância magnética',
      },
      {
        value: '8640207',
        label:
          'Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética',
      },
      {
        value: '8640208',
        label:
          'Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos',
      },
      {
        value: '8640209',
        label:
          'Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos',
      },
      {
        value: '8640210',
        label: 'Serviços de quimioterapia',
      },
      {
        value: '8640211',
        label: 'Serviços de radioterapia',
      },
      {
        value: '8640212',
        label: 'Serviços de hemoterapia',
      },
      {
        value: '8640213',
        label: 'Serviços de litotripcia',
      },
      {
        value: '8640214',
        label: 'Serviços de bancos de células e tecidos humanos',
      },
      {
        value: '8640299',
        label:
          'Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente',
      },
      {
        value: '8650001',
        label: 'Atividades de enfermagem',
      },
      {
        value: '8650002',
        label: 'Atividades de profissionais da nutrição',
      },
      {
        value: '8650003',
        label: 'Atividades de psicologia e psicanálise',
      },
      {
        value: '8650004',
        label: 'Atividades de fisioterapia',
      },
      {
        value: '8650005',
        label: 'Atividades de terapia ocupacional',
      },
      {
        value: '8650006',
        label: 'Atividades de fonoaudiologia',
      },
      {
        value: '8650007',
        label: 'Atividades de terapia de nutrição enteral e parenteral',
      },
      {
        value: '8650099',
        label:
          'Atividades de profissionais da área de saúde não especificadas anteriormente',
      },
      {
        value: '8660700',
        label: 'Atividades de apoio à gestão de saúde',
      },
      {
        value: '8690901',
        label:
          'Atividades de práticas integrativas e complementares em saúde humana',
      },
      {
        value: '8690902',
        label: 'Atividades de banco de leite humano',
      },
      {
        value: '8690903',
        label: 'Atividades de acupuntura',
      },
      {
        value: '8690904',
        label: 'Atividades de podologia',
      },
      {
        value: '8690999',
        label:
          'Outras atividades de atenção à saúde humana não especificadas anteriormente',
      },
      {
        value: '8711501',
        label: 'Clínicas e residências geriátricas',
      },
      {
        value: '8711502',
        label: 'Instituições de longa permanência para idosos',
      },
      {
        value: '8711503',
        label:
          'Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes',
      },
      {
        value: '8711504',
        label: 'Centros de apoio a pacientes com câncer e com AIDS',
      },
      {
        value: '8711505',
        label: 'Condomínios residenciais para idosos e deficientes físicos',
      },
      {
        value: '8712300',
        label:
          'Atividades de fornecimento de infra-estrutura de apoio e assistência a paciente no domicílio',
      },
      {
        value: '8720401',
        label: 'Atividades de centros de assistência psicossocial',
      },
      {
        value: '8720499',
        label:
          'Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química e grupos similares não',
      },
      {
        value: '8730101',
        label: 'Orfanatos',
      },
      {
        value: '8730102',
        label: 'Albergues assistenciais',
      },
      {
        value: '8730199',
        label:
          'Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente',
      },
      {
        value: '8800600',
        label: 'Serviços de assistência social sem alojamento',
      },
      {
        value: '9001901',
        label: 'Produção teatral',
      },
      {
        value: '9001902',
        label: 'Produção musical',
      },
      {
        value: '9001903',
        label: 'Produção de espetáculos de dança',
      },
      {
        value: '9001904',
        label: 'Produção de espetáculos circenses, de marionetes e similares',
      },
      {
        value: '9001905',
        label: 'Produção de espetáculos de rodeios, vaquejadas e similares',
      },
      {
        value: '9001906',
        label: 'Atividades de sonorização e de iluminação',
      },
      {
        value: '9001999',
        label:
          'Artes cênicas, espetáculos e atividades complementares não especificadas anteriormente',
      },
      {
        value: '9002701',
        label:
          'Atividades de artistas plásticos, jornalistas independentes e escritores',
      },
      {
        value: '9002702',
        label: 'Restauração de obras-de-arte',
      },
      {
        value: '9003500',
        label:
          'Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas',
      },
      {
        value: '9101500',
        label: 'Atividades de bibliotecas e arquivos',
      },
      {
        value: '9102301',
        label:
          'Atividades de museus e de exploração de lugares e prédios históricos e atrações similares',
      },
      {
        value: '9102302',
        label: 'Restauração e conservação de lugares e prédios históricos',
      },
      {
        value: '9103100',
        label:
          'Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental',
      },
      {
        value: '9200301',
        label: 'Casas de bingo',
      },
      {
        value: '9200302',
        label: 'Exploração de apostas em corridas de cavalos',
      },
      {
        value: '9200399',
        label:
          'Exploração de jogos de azar e apostas não especificados anteriormente',
      },
      {
        value: '9311500',
        label: 'Gestão de instalações de esportes',
      },
      {
        value: '9312300',
        label: 'Clubes sociais, esportivos e similares',
      },
      {
        value: '9313100',
        label: 'Atividades de condicionamento físico',
      },
      {
        value: '9319101',
        label: 'Produção e promoção de eventos esportivos',
      },
      {
        value: '9319199',
        label: 'Outras atividades esportivas não especificadas anteriormente',
      },
      {
        value: '9321200',
        label: 'Parques de diversão e parques temáticos',
      },
      {
        value: '9329801',
        label: 'Discotecas, danceterias, salões de dança e similares',
      },
      {
        value: '9329802',
        label: 'Exploração de boliches',
      },
      {
        value: '9329803',
        label: 'Exploração de jogos de sinuca, bilhar e similares',
      },
      {
        value: '9329804',
        label: 'Exploração de jogos eletrônicos recreativos',
      },
      {
        value: '9329899',
        label:
          'Outras atividades de recreação e lazer não especificadas anteriormente',
      },
      {
        value: '9411100',
        label:
          'Atividades de organizações associativas patronais e empresariais',
      },
      {
        value: '9412000',
        label: 'Atividades de organizações associativas profissionais',
      },
      {
        value: '9412001',
        label: 'Atividades de fiscalização profissional',
      },
      {
        value: '9412099',
        label: 'Outras atividades associativas profissionais',
      },
      {
        value: '9420100',
        label: 'Atividades de organizações sindicais',
      },
      {
        value: '9430800',
        label: 'Atividades de associações de defesa de direitos sociais',
      },
      {
        value: '9491000',
        label: 'Atividades de organizações religiosas ou filosóficas',
      },
      {
        value: '9492800',
        label: 'Atividades de organizações políticas',
      },
      {
        value: '9493600',
        label:
          'Atividades de organizações associativas ligadas à cultura e à arte',
      },
      {
        value: '9499500',
        label: 'Atividades associativas não especificadas anteriormente',
      },
      {
        value: '9511800',
        label:
          'Reparação e manutenção de computadores e de equipamentos periféricos',
      },
      {
        value: '9512600',
        label: 'Reparação e manutenção de equipamentos de comunicação',
      },
      {
        value: '9521500',
        label:
          'Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico',
      },
      {
        value: '9529101',
        label: 'Reparação de calçados, bolsas e artigos de viagem',
      },
      {
        value: '9529102',
        label: 'Chaveiros',
      },
      {
        value: '9529103',
        label: 'Reparação de relógios',
      },
      {
        value: '9529104',
        label:
          'Reparação de bicicletas, triciclos e outros veículos não-motorizados',
      },
      {
        value: '9529105',
        label: 'Reparação de artigos do mobiliário',
      },
      {
        value: '9529106',
        label: 'Reparação de jóias',
      },
      {
        value: '9529199',
        label:
          'Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente',
      },
      {
        value: '9601701',
        label: 'Lavanderias',
      },
      {
        value: '9601702',
        label: 'Tinturarias',
      },
      {
        value: '9601703',
        label: 'Toalheiros',
      },
      {
        value: '9602501',
        label: 'Cabeleireiros, manicure e pedicure',
      },
      {
        value: '9602502',
        label:
          'Atividades de estética e outros serviços de cuidados com a beleza',
      },
      {
        value: '9603301',
        label: 'Gestão e manutenção de cemitérios',
      },
      {
        value: '9603302',
        label: 'Serviços de cremação',
      },
      {
        value: '9603303',
        label: 'Serviços de sepultamento',
      },
      {
        value: '9603304',
        label: 'Serviços de funerárias',
      },
      {
        value: '9603305',
        label: 'Serviços de somatoconservação',
      },
      {
        value: '9603399',
        label:
          'Atividades funerárias e serviços relacionados não especificados anteriormente',
      },
      {
        value: '9609201',
        label: 'Clinicas de estética e similares',
      },
      {
        value: '9609202',
        label: 'Agências matrimoniais',
      },
      {
        value: '9609203',
        label: 'Alojamento, higiene e embelezamento de animais',
      },
      {
        value: '9609204',
        label:
          'Exploração de máquinas de serviços pessoais acionadas por moeda',
      },
      {
        value: '9609205',
        label: 'Atividades de sauna e banhos',
      },
      {
        value: '9609206',
        label: 'Serviços de tatuagem e colocação de piercing',
      },
      {
        value: '9609207',
        label: 'Alojamento de animais domésticos',
      },
      {
        value: '9609208',
        label: 'Higiene e embelezamento de animais domésticos',
      },
      {
        value: '9609299',
        label:
          'Outras atividades de serviços pessoais não especificadas anteriormente',
      },
      {
        value: '9700500',
        label: 'Serviços domésticos',
      },
      {
        value: '9900800',
        label:
          'Organismos internacionais e outras instituições extraterritoriais',
      },
      {
        value: '8888888',
        label: 'Atividade Econônica não informada',
      },
    ],
  },
  {
    idCollection: ['12d2cbd0-52a0-44c6-993a-e150e7a60c04'],
    data: [
      { label: 'SC', value: 'SC' },
      { label: 'MT', value: 'MT' },
      { label: 'MS', value: 'MS' },
      { label: 'PI', value: 'PI' },
      { label: 'AM', value: 'AM' },
      { label: 'AC', value: 'AC' },
      { label: 'GO', value: 'GO' },
      { label: 'MG', value: 'MG' },
      { label: 'CE', value: 'CE' },
      { label: 'RO', value: 'RO' },
      { label: 'RS', value: 'RS' },
      { label: 'PB', value: 'PB' },
      { label: 'AL', value: 'AL' },
      { label: 'PR', value: 'PR' },
      { label: 'BA', value: 'BA' },
      { label: 'MA', value: 'MA' },
      { label: 'SE', value: 'SE' },
      { label: 'PA', value: 'PA' },
      { label: 'DF', value: 'DF' },
      { label: 'RJ', value: 'RJ' },
      { label: 'ES', value: 'ES' },
      { label: 'RN', value: 'RN' },
      { label: 'RR', value: 'RR' },
      { label: 'SP', value: 'SP' },
      { label: 'TO', value: 'TO' },
      { label: 'PE', value: 'PE' },
      { label: 'AP', value: 'AP' },
    ],
  },
  {
    idCollection: ['af060ca7-2e88-4a39-a340-2364026cd9d8'],
    data: [
      { label: 'Não', value: 'N' },
      { label: 'Sim', value: 'S' },
    ],
  },
  {
    idCollection: ['85ab63fa-2709-47ec-8b14-485bb9c073ae'],
    data: [
      { label: 'Empresa Ativa', value: 'ATIVA' },
      { label: 'Empresa Baixada', value: 'BAIXADA' },
      { label: 'Empresa Suspensa', value: 'SUSPENSA' },
      { label: 'Empresa Nula', value: 'NULA' },
      { label: 'Empresa Inapta', value: 'INAPTA' },
    ],
  },
  {
    idCollection: ['1a0be264-3b3a-48d4-8299-55050d90aa03'],
    data: [
      { label: 'Não', value: 'N' },
      { label: 'Sim', value: 'S' },
    ],
  },
  {
    idCollection: ['9c23c735-2e0c-4e99-9b4f-0177184f5c48'],
    data: [
      { label: 'Filial', value: '0' },
      { label: 'Matriz', value: '1' },
    ],
  },
  {
    idCollection: ['5cb47d2a-2012-4aa1-93ad-170259f2dd0f'],
    data: [
      { label: 'LUCRO REAL', value: 'LUCRO REAL' },
      { label: 'LUCRO REAL/ARBITRADO', value: 'LUCRO REAL/ARBITRADO' },
      {
        label: 'LUCRO PRESUMIDO/REAL/ARBITRADO',
        value: 'LUCRO PRESUMIDO/REAL/ARBITRADO',
      },
      {
        label: 'LUCRO PRESUMIDO/ARBITRADO',
        value: 'LUCRO PRESUMIDO/ARBITRADO',
      },
      { label: 'LUCRO PRESUMIDO/REAL', value: 'LUCRO PRESUMIDO/REAL' },
      { label: 'ISENTA DO IRPJ', value: 'ISENTA DO IRPJ' },
      { label: 'LUCRO PRESUMIDO', value: 'LUCRO PRESUMIDO' },
      { label: 'LUCRO ARBITRADO', value: 'LUCRO ARBITRADO' },
      { label: 'IMUNE DO IRPJ', value: 'IMUNE DO IRPJ' },
    ],
  },
];
